export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Cartier Philanthropy – Dix ans de philanthropy efficace",
    "shortTitle": "",
    "description": "",
    "width": 714,
    "height": 868,
    "currentLanguage": "FR",
    "languages": [{
      "code": "EN",
      "text": "English",
      "href": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/en"
    },{
      "code": "FR",
      "text": "French",
      "href": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/fr"
    }],
    "basePath": "/a-decade-of-effective-philanthropy/fr",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://reports.cartierphilanthropy.org/a-decade-of-effective-philanthropy/fr/static/_thumbs",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/a-decade-of-effective-philanthropy/fr/static/_content/Cartier-Philanthropy-Dix-ans-de-philanthropy-efficace.pdf',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {}
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 2-logo" style="top:228px;left:963px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/2-logo-1.png">
        <img class="abs halfScale 2-title" style="top:513px;left:1051px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/2-title-1.png">
        <img class="abs halfScaleC 2-logo" style="top:740px;left:1031px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/2-logo-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim
            .staggerFromTo(cOf("2-logo"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.6, 1)
            .fromTo(cOf("2-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
        }

        function onPageLeave() {
          pg2Anim.stop();
          resetNumbers("2-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DIX ANS DE PHILANTHROPIE E FFI C A C E"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 3-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-title-1.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-1.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-2.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-3.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-4.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-5.png">
        <img class="abs halfScaleC 3-pie" style="top:309px;left:136px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/3-pie-6.png">
        <h1 id="3-no" class="abs brillCutReg 3-no" style="top:176px;left:254px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;"  data-number='{"to": 100, "comma": true}' ></h1>
        <h1 id="3-no" class="abs brillCutReg 3-no" style="top:286px;left:391px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;"  data-number='{"to": 50, "preppend": "+"}' ></h1>

        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 52, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:500px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 25, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:523px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 10, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:561px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 6, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:584px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 1, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:608px;left:110px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 6, "append": "%"}' ></h1>
        `,
        "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim
            .fromTo(cOf("3-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .staggerFromTo(cOf("3-pie"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.9)
          
          animateNumbers("3-no", 1.3)
        }
        
        function onPageLeave() {
          pg3Anim.stop();
          resetNumbers("3-no");
          removeContentLinks();
          removeContentLinksThree();
        }
        `,
        "searchText": "ALLOCATION BUDGÉTAIRE  100  millions de francs suisses investis sur les dix dernières années  +50 Distribution géographique 5 2% Afrique 2 5% Asie 1 0% Amérique centrale & latine 6 % Europe* 1% Moyen-Orient 6% Autres*  *Inclut un soutien exceptionnel pendant la pandémie de Coronavirus (2020-2022)  2-  pays"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
        <h1 id="3-no" class="abs brillCutReg 3-no" style="top:241px;left:81px; font-size: 4.4em; font-weight: 300; color: #868687; padding: 0px; margin: 0px;"  data-number='{"to": 80, "preppend": "+"}' ></h1>

        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:105px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 41, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:311px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:428px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 21, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:476px;left:537px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 15, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:115px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 33, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:268px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px;margin: 0px;"  data-number='{"to": 24, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:390px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%"}' ></h1>
        <h1 id="3-no" class="abs brillCutBold 3-no" style="top:766px;left:498px; font-size: 0.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 20, "append": "%"}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();

          animateNumbers("3-no", 1.3)
        }

        function onPageLeave() {
          pg4Anim.stop();
          resetNumbers("3-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+80  partenaires  Par secteur 4 1% Accès aux services de base  33% Éducation  2 3% Développement social et économique des femmes  24% Santé  2 1% Modes de subsistance et écosystèmes durables  23% Eau et assainissement  1 5% Réponse aux situations d’urgence  20% Nutrition  - 3"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 6-title" style="top:286px;left:333px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/6-title-1.png">
        <img class="abs halfScale 6-title" style="top:384px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/6-text-1.png">
        <img class="abs halfScale 6-title" style="top:478px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/6-text-2.png">
        <img class="abs halfScale 6-title" style="top:574px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/6-text-3.png">
        <img class="abs halfScale 6-title" style="top:669px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/6-text-4.png">

        <div class="contentLinkNone" onclick="Publish.goToPage(6);" style="top: 379px; left: 353px; width: 186px; height: 44px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(7);" style="top: 476px; left: 353px; width: 270px; height: 44px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(8);" style="top: 571px; left: 353px; width: 298px; height: 44px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(42);" style="top: 652px; left: 353px; width: 308px; height: 61px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim
            .staggerFromTo(cOf("6-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg6Anim.stop();
          resetNumbers("6-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SOM M A I R E  06  Message du Président  07  Message de la Conseillère stratégique  08  Dix ans d’impact collectif dans nos domaines clés  42  Les cinq leçons tirées d’une décennie d’engagement  XXX - 5"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 7-title" style="top:87px;left:88px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/7-title-1.png">

      <div class="contentLinkNone abs" style="top: 195px; left: 282px; width: 368px; height: 567px;" onclick="Publish.openArticle(0)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim
            .fromTo(cOf("7-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg7Anim.stop();
          resetNumbers("7-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MESSAGE DU PRÉSIDENT  CYRILLE VIGNERON  Président et CEO de Cartier, Président du conseil de fondation Cartier Philanthropy  6-  La mission de Cartier est de trouver la beauté, où qu’elle soit. Nous sommes à son service et, tous les jours, nous nous efforçons de la sublimer afin qu’elle perdure pour les générations à venir. Nous estimons qu’il est de notre responsabilité, à la fois en tant qu’être humain et en tant qu’entreprise, de cultiver et de protéger la beauté du monde, et de faire tout notre possible pour la restaurer quand elle a été détériorée ou brisée. La vie humaine est évidemment l’une des beautés du monde. La beauté, telle que nous la concevons, est donc un idéal qui ne peut être atteint que par le soin, le respect, la dignité et la compassion. Au cours de cette dernière décennie, Cartier Philanthropy a travaillé avec ténacité et efficacité pour améliorer la vie des communautés les plus vulnérables et les plus marginalisées de la planète, afin qu’elles puissent non seulement survivre aux épreuves, mais vivre, profiter et participer pleinement à la beauté du monde. Une jeune fille qui termine avec succès sa scolarité, une communauté d’agriculteurs prospère, un endroit sûr où trouver refuge et se reconstruire, un nouveau-né en bonne santé… sont autant d’expressions de la beauté - une beauté vivante. Cartier Philanthropy soutient des organisations dont la mission est de donner aux femmes, aux enfants et à des communautés entières les ressources, les compétences et les opportunités dont ils ont besoin pour vivre pleinement. Au fil des années, de solides partenariats ont été noués et construits sur des valeurs communes et un engagement mutuel en faveur d’une philanthropie efficace. Le chemin est encore long. En effet, à certaines occasions, il peut même nous paraître plus sinueux qu’il ne l’était il y a dix ans. Mais chaque pas et chaque vie changée viennent réaffirmer notre confiance et notre détermination, et ouvrent en peu plus la voie afin que d’autres nous rejoignent pour créer ensemble de nouvelles beautés dans le monde."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 8-title" style="top:87px;left:72px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/8-title-1.png">
        <div class="contentLinkNone abs" style="top: 195px; left: 264px; width: 368px; height: 631px;" onclick="Publish.openArticle(1)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim
            .fromTo(cOf("8-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
        }

        function onPageLeave() {
          pg8Anim.stop();
          resetNumbers("8-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MESSAGE DE LA CONSEILLÈRE STRATÉGIQUE  PASCALE DE LA FRÉGONNIÈRE Conseillère stratégique Cartier Philanthropy  Quelle aventure ces dix dernières années ! Et quel privilège que celui de guider Cartier Philanthropy, des promesses initiales aux progrès tangibles, en créant un solide réseau de partenaires dont nous sommes très fiers ! Nous sommes aujourd’hui heureux de voir, aux quatre coins du monde, des communautés plus fortes et pleines de ressources, en mesure de surmonter de sérieux obstacles et de vivre enfin comme elles le méritent. Cartier Philanthropy a été fondé il y a dix ans afin de participer à la construction d’un monde dans lequel chacun peut réaliser son potentiel. Au cours de la dernière décennie, nous nous sommes concentrés sur cette ambition de manière stratégique. Nous avons choisi de nous focaliser sur les endroits les plus vulnérables de la planète et avons progressivement défini le cadre de notre champ d’action, en accordant une attention particulière aux inégalités qui maintiennent les gens dans la pauvreté. La philanthropie relève de l’action collective et d’objectifs communs. Avec nos partenaires, nous nous attaquons sans relâche à ces inégalités, qu’elles soient liées au genre, à l’accès aux services essentiels ou au manque de ressources matérielles et sociales. Ce rapport met en lumière l’impact de notre engagement collectif et les changements concrets qui ont permis d’améliorer la vie des plus démunis. C’est notre façon d’honorer nos partenaires pour leur courage et leur détermination dans leur combat au service des plus vulnérables, quelles que soient les difficultés. Car ce combat est aussi le nôtre. Conscients qu’une évolution significative et durable ne se produit que si nous nous concentrons aussi sur notre façon de donner afin de contribuer à un impact social fort, nous partageons aussi dans ce rapport certaines des leçons que nous avons apprises en chemin, nous aidant à devenir une fondation meilleure, plus efficace, responsable et participative. Construire une société inclusive, équitable et plus sûre, qui offre à chacun la possibilité de mener une vie épanouissante, reste un impératif moral et le défi de notre époque. Notre engagement demeure inchangé, tout comme notre ambition de soutenir et de déployer des interventions éprouvées à l’échelle des besoins du plus grand nombre. - 7"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 10-title" style="top:365px;left:335px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/10-title-1.png">
        <img class="abs halfScale 10-title" style="top:433px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/10-sub-1.png">
        <img class="abs halfScale 10-title" style="top:590px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/10-text-1.png">
        <img class="abs halfScale 10-title" style="top:642px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/10-text-2.png">
        <img class="abs halfScale 10-title" style="top:716px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/10-text-3.png">
        <img class="abs halfScale 10-title" style="top:786px;left:357px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/10-text-4.png">

        <div class="contentLinkNone" onclick="Publish.goToPage(11);" style="top: 588px; left: 351px; width: 290px; height: 24px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(19);" style="top: 642px; left: 351px; width: 290px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(27);" style="top: 714px; left: 351px; width: 290px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(35);" style="top: 784px; left: 351px; width: 290px; height: 43px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim
            .staggerFromTo(cOf("10-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg10Anim.stop();
          resetNumbers("10-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DIX ANS D’IMPACT COLLECTIF DANS NOS DOMAINES CLÉS 1.  ACCÈS AUX SERVICES DE BASE 2. DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES 3. MODES DE SUBSISTANCE ET ÉCOSYSTÈMES DURABLES 4. RÉPONSE AUX SITUATIONS D’URGENCE XXX - 9"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "10 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 12-title" style="top:263px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/12-title-1.png">
        <img class="abs halfScale 12-title" style="top:426px;left:331px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/12-text-1.png">
        <div class="12-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/Cartier_Access to Basic Services_V9_Subbed.mp4')" style="top: 356px; left: 545px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim
            .staggerFromTo(cOf("12-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("12-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg12Anim.stop();
          resetNumbers("12-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCÈS AUX SERVICES DE BASE Pour mener une vie épanouie, nos besoins fondamentaux doivent être satisfaits. Ces besoins comprennent l’accès aux soins médicaux, à une éducation de qualité, à une alimentation équilibrée, à l’eau potable et à l’assainissement. Durant cette dernière décennie, nous nous sommes associés à des douzaines d’organisations qui travaillent sans relâche et avec rigueur afin d’améliorer l’accès à ces services de base dans les régions les plus reculées du monde. XXX - 11"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 13-title" style="top:101px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-title-1.png">
        <img class="abs halfScaleR 13-line" style="top:98px;left:-715px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-line-1.png">
        <h1 id="13-no" class="abs fancyCutMediumStretch 13-no" style="top: 406px; left: 110px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 30, "append": "%"}' ></h1>
        <img class="abs halfScale 13-text" style="top:439px;left:103px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-text-1.png">
        <img class="abs halfScale 13-image" style="top:566px;left:102px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-image-1.png">
        <img class="abs halfScaleR 13-line" style="top:423px;left:-109px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-line-2.png">
        <h1 id="13-no" class="abs fancyCutMediumStretch 13-no" style="top: 625px; left: 501px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 38, "append": "%"}' ></h1>
        <img class="abs halfScale 13-text" style="top:658px;left:493px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-text-2.png">
        <img class="abs halfScale 13-image" style="top:407px;left:352px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-image-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim
            .fromTo(cOf("13-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("13-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("13-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[0])}}, 1.45)
            .fromTo(cOf("13-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("13-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("13-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("13-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[1])}}, 2.35)
            .fromTo(cOf("13-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("13-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg13Anim.stop();
          resetNumbers("13-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCÈS AUX SOINS DE SANTÉ  Tog o  30%  baisse du taux de mortalité des enfants de moins de cinq ans, sur une période de cinq ans, grâce à la prise en charge communautaire de Santé Intégrée dans le district de Kozah  Zambie  0  14%  baisse au niveau national  0  38%  15 15 30 30  12 - A CCÈ S A UX SER VICES D E BA SE  réduction de la morbidité des élèves dans les écoles de Lusaka où les enseignants sont formés comme agents de santé scolaire par Healthy Learners"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `
      <h1 id="14-no" class="abs fancyCutMediumStretch 14-no" style="top: 640px; left: 241px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 33, "append": "%"}' ></h1>
      <img class="abs halfScale 14-line-b" style="top:445px;left:424px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/14-line-3.png">
      <img class="abs halfScale 14-text" style="top:674px;left:234px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/14-text-1.png">
      <img class="abs halfScale 14-image" style="top:576px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/14-image-1.png">
      <img class="abs halfScale 14-map" style="top:111px;left:79px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/14-map-1.png">
      <img class="abs halfScaleR 14-line" style="top:98px;left:-1429px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-line-1.png">
        <img class="abs halfScaleR 14-line" style="top:423px;left:-822px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/13-line-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim
            .fromTo(cOf("14-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("14-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("14-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("14-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("14-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("14-no")[0])}}, 2.35)
            .fromTo(cOf("14-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("14-line-b"), 0.6, {opacity:0, y: 30}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg14Anim.stop();
          resetNumbers("13-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "AFRIQUE  0  15  30  33%  baisse du taux de Madagascar mortalité infantile dans les zones du district d’Ifanadiana où les équipes de Pivot ont travaillé entre 2014 et 2021, contre une hausse de 48 % ailleurs dans le district AC C ÈS AUX S ERVIC ES DE BAS E - 13"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 15-title" style="top:101px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-title-1.png">
        <img class="abs halfScaleR 15-line" style="top:190px;left:-838px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-line-1.png">
        <h1 id="15-no" class="abs fancyCutMediumStretch 15-no" style="top: 685px; left: 112px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 75, "append": "%"}' ></h1>
        <img class="abs halfScale 15-text" style="top:718px;left:104px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-text-2.png">
        <img class="abs halfScale originBC 15-image" style="bottom:199px;left:10px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-image-1.png">
        <img class="abs halfScaleR 15-line" style="top:271px;left:-290px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-line-2.png">
        <h1 id="15-no" class="abs fancyCutMediumStretch 15-no" style="top: 392px; left: 492px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 19, "append": "%"}' ></h1>
        <img class="abs halfScale 15-text" style="top:423px;left:487px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-text-1.png">
        <img class="abs halfScale originBC 15-image" style="bottom:307px;left:314px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-image-2.png">
        <img class="abs halfScaleC 15-image" style="top:479px;left:170px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-image-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim
            .fromTo(cOf("15-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("15-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("15-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("15-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("15-no")[0])}}, 1.6)
            .fromTo(cOf("15-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("15-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("15-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("15-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("15-no")[1])}}, 2.35)
            .fromTo(cOf("15-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("15-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg15Anim.stop();
          resetNumbers("15-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCÈS À L’ÉDUCATION  É t h iop ie  R w a nd a  75  19% 60  45  30  15  0  75%  des élèves du programme « Seconde Chance » de Luminos Fund sont toujours scolarisés six ans plus tard 14 - A CCÈ S A UX SER VICES D E BA SE  15  0  taux d’amélioration de la résilience émotionnelle chez les enfants inscrits au programme de formation à la résilience de CorStone au Rwanda"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 16-line" style="top:190px;left:-1551px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-line-1.png">
        <img class="abs halfScaleR 16-line" style="top:271px;left:-1004px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/15-line-2.png">
        <img class="abs halfScaleR 16-line" style="top:173px;left:218px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/16-line-3.png">
        <img class="abs halfScale originBC 16-image" style="bottom:58px;left:175px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/16-image-1.png">
        <h1 id="16-no" class="abs fancyCutMediumStretch 16-no" style="top: 503px; left: 439px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 66, "append": "%"}' ></h1>
        <img class="abs halfScale 16-text" style="top:537px;left:431px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/16-text-1.png">
        <div class="abs" style="top: 581px; left: -1px; width: 5px; height: 241px; background: white;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim
            .fromTo(cOf("16-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("16-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("16-line")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("16-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("16-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[0])}}, 2.65)
            .fromTo(cOf("16-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Bangladesh  66% 60  45  30  taux d’amélioration de l’alphabétisation chez les enfants qui utilisent le modèle d’apprentissage sur tablette d’Image Worldwide, éprouvé au Malawi et désormais testé au Bangladesh  15  0  AC C ÈS AUX S ERVIC ES DE BAS E - 15"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 17-title" style="top:83px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-title-1.png">
        <img class="abs halfScaleR 17-line" style="top:304px;left:-64px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-line-1.png">
        <h1 id="17-no" class="abs fancyCutMediumStretch 17-no" style="top: 461px; left: 117px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 12600, "comma": true}' ></h1>
        <img class="abs halfScale 17-text" style="top:496px;left:105px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-text-1.png">
        <img class="abs halfScale originBC 17-image" style="bottom:42px;left:1px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-image-1.png">
        <img class="abs halfScaleR 17-line" style="top:290px;left:103px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-line-2.png">
        <h1 id="17-no" class="abs fancyCutMediumStretch 17-no" style="top: 615px; left: 115px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 300000, "comma": true}' ></h1>
        <h1 id="17-no" class="abs fancyCutMediumStretch 17-no" style="top: 662px; left: 475px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 12000, "comma": true, "preppend": "+"}' ></h1>
        <img class="abs halfScale 17-text" style="top:696px;left:466px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-text-2.png">
        <img class="abs halfScale originBC 17-image" style="bottom:219px;left:322px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-image-2.png">
        <img class="abs halfScaleC 17-image" style="top:258px;left:205px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/17-image-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim
            .fromTo(cOf("17-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("17-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("17-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("17-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[0])}}, 1.6)
            .fromTo(cOf("17-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("17-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[1])}}, 1.75)
            .fromTo(cOf("17-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("17-line")[1], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("17-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("17-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("17-no")[2])}}, 2.5)
            .fromTo(cOf("17-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg17Anim.stop();
          resetNumbers("17-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCÈS À L’EAU, À L’ASSAINISSEMENT ET À LA NUTRITION  Guatemala  Haïti  12 600  agriculteurs ont cultivé des semences bio-fortifiées de Semilla Nueva en 2021, ce qui a permis de fournir du maïs nutritif à plus de  300 000 personnes  +12 000  Haïtiens utilisent aujourd’hui les toilettes conçues par SOIL ainsi que le service de collecte et de transformation des déchets en compost  16 - A CCÈ S A UX SER VICES D E BA SE"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 18-line" style="top:311px;left:-64px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/18-line-1.png">
        <img class="abs halfScale 18-text" style="top:594px;left:344px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/18-text-1.png">
        <img class="abs halfScale originBC 18-image" style="bottom:48px;left:-22px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/18-image-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim
            .fromTo(cOf("18-line"), 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("18-image"), 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("18-text"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
        }

        function onPageLeave() {
          pg18Anim.stop();
          resetNumbers("18-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "C am b o d g e  1 ménage sur 4  dans les régions rurales du Cambodge – 850 000 personnes – boit de l’eau potable chaque jour grâce aux kiosques à eau de 1001fontaines AC C ÈS AUX S ERVIC ES DE BAS E - 17"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "18 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 20-title" style="top:251px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/20-title-1.png">
        <img class="abs halfScale 20-title" style="top:453px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/20-text-1.png">
        <div class="20-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/womens_engagement_V7_Hardsubbed.mp4')" style="    top:379px; left: 620px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim
            .staggerFromTo(cOf("20-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("20-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg20Anim.stop();
          resetNumbers("20-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES Pendant dix ans, nous avons aidé nos partenaires à s’attaquer aux déséquilibres de pouvoir, aux préjugés et stéréotypes de genre et aux barrières sociales et économiques qui freinent l’avancement des femmes. Leurs remarquables résultats en matière de santé, de droits reproductifs, d’opportunités professionnelles, d’entrepreneuriat, d’éducation et de libre arbitre ont contribué à bâtir un monde plus équitable. XXX - 19"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 21-title" style="top:100px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-title-1.png">
        <img class="abs halfScaleR 21-line" style="top:218px;left:-332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-line-1.png">
        <h1 id="21-no" class="abs fancyCutMediumStretch 21-no" style="top: 364px; left: 278px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 2000, "comma": true}' ></h1>
        <img class="abs halfScale 21-text" style="top:397px;left:266px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-text-1.png">
        <img class="abs halfScale originBC 21-image" style="bottom:520px;left:5px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-image-1.png">
        <h1 id="21-no" class="abs fancyCutMediumStretch 21-no" style="top: 364px; left: 98px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 770000, "preppend": "+", "comma": true}' ></h1>
        <img class="abs halfScale 21-text" style="top:399px;left:88px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-text-2.png">
        <img class="abs halfScaleR 21-line" style="top:381px;left:-389px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-line-2.png">
        <img class="abs halfScale originBC 21-image" style="bottom:123px;left:8px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-image-2.png">
        <h1 id="21-no" class="abs fancyCutMediumStretch 21-no" style="top: 724px; left: 269px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 0.8, "append": "%", "decimals": 1}' ></h1>
        <img class="abs halfScaleC 21-text" style="top:723px;left:74px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-text-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim
            .fromTo(cOf("21-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("21-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("21-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[0])}}, 1.45)
            .fromTo(cOf("21-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("21-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("21-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[1])}}, 2.05)
            .fromTo(cOf("21-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("21-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("21-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("21-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[2])}}, 2.8)
            .fromTo(cOf("21-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
        }

        function onPageLeave() {
          pg21Anim.stop();
          resetNumbers("21-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "SANTÉ DES FEMMES  Sénégal  +770 000 grossesses non désirées évitées au Sénégal depuis 2011 grâce aux services de MSI Reproductive Choices  2 000  décès maternels évités depuis 2011  = 100 décès maternels  Ouganda  0,8%  taux de transmission du VIH-SIDA de la mère à l’enfant en Ouganda où l’organisation mothers2mothers est active, contre un taux de 40 % où ses services ne sont pas présents 20 - DÉ V E LO PP EM EN T SO CIA L ET ÉCO N O MIQUE DES FEMMES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 22-line" style="top:218px;left:-1046px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-line-1.png">
        <img class="abs halfScaleR 22-line" style="top:381px;left:-1104px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/21-line-2.png">
        <h1 id="22-no" class="abs fancyCutMediumStretch 22-no" style="top: 719px; left: 359px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 120000, "comma": true}' ></h1>
        <img class="abs halfScale 22-text" style="top:754px;left:347px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/22-text-1.png">
        <img class="abs halfScale originBC 22-image" style="bottom:50px;left:-119px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/22-image-1.png">
        <img class="abs halfScaleR 22-line-b" style="top:467px;left:237px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/22-line-1.png">
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim
            .fromTo(cOf("22-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("22-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("22-line-b"), 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("22-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[0])}}, 2.95)
            .fromTo(cOf("22-text"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("22-image"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.15)
        }

        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "AFRIQUE  Zambie  120 000  femmes souffrant de dépression traitées en Zambie par le modèle de thérapie collective de StrongMinds  D É VELOPPEMENT S OC IAL ET ÉC ONOMIQUE DES FEMMES - 21"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 23-title" style="top:99px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-title-1.png">
        <img class="abs halfScaleR 23-line" style="top:221px;left:-721px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-line-1.png">
        <h1 id="23-no" class="abs fancyCutMediumStretch 23-no" style="top: 274px; left: 434px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 1.1, "decimals": 1, "append": "M"}' ></h1>
        <img class="abs halfScale 23-text" style="top:310px;left:427px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-text-1.png">
        <img class="abs halfScale originBC 23-image" style="bottom:467px;left:172px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-image-1.png">
        <h1 id="23-no" class="abs fancyCutMediumStretch 23-no" style="top: 503px; left: 100px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 15000, "comma": true}' ></h1>
        <img class="abs halfScale 23-text" style="top:430px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-text-2.png">
        <img class="abs halfScale originBC 23-image" style="bottom:63px;left:331px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-image-2.png">
        <h1 id="23-no" class="abs fancyCutMediumStretch 23-no" style="top: 590px; left: 521px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 90, "append": "%"}' ></h1>
        <img class="abs halfScaleC 23-image" style="top:488px;left:-59px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-image-3.png">
        <img class="abs halfScaleC 23-text" style="top:600px;left:473px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-text-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim
            .fromTo(cOf("23-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("23-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("23-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0])}}, 1.6)
            .fromTo(cOf("23-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("23-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("23-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[1])}}, 2.2)
            .fromTo(cOf("23-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("23-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("23-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[2])}}, 2.95)
            .fromTo(cOf("23-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ÉDUCATION ET COMPÉTENCES DE VIE 1,1M de filles indiennes de retour à l’école grâce à Educate Girls  Inde  15 000  bénévoles communautaires composent l’équipe d’Educate Girls  = 250 bénévoles communautaires  100%  90%  taux de rétention des élèves  0%  22 - DÉ V E LO PP EM EN T SO CIA L ET ÉCO N O MIQUE DES FEMMES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 24-line" style="top:221px;left:-1437px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/23-line-1.png">
        <img class="abs halfScaleR 24-line" style="top:420px;left:311px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/24-line-2.png">
        <img class="abs halfScaleR 24-line" style="top:277px;left:154px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/24-line-1.png">
        <img class="abs halfScale originBC 24-image" style="bottom:123px;left:-40px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/24-image-1.png">
        <h1 id="24-no" class="abs fancyCutMediumStretch 24-no" style="top: 670px; left: 137px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 79, "append": "%"}' ></h1>
        <img class="abs halfScale 24-text" style="top:755px;left:72px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/24-text-1.png">
        <h1 id="24-no" class="abs fancyCutMediumStretch 24-no" style="top: 708px; left: 396px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%"}' ></h1>
        <img class="abs halfScale 24-text" style="top:742px;left:391px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/24-text-2.png">
        <img class="abs halfScale originBC 24-image" style="bottom:133px;left:428px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/24-image-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          pg24Anim
            .fromTo(cOf("24-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("24-line")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("24-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("24-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[0])}}, 1.9)
            .fromTo(cOf("24-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("24-line")[2], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("24-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[1])}}, 2.5)
            .fromTo(cOf("24-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("24-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg24Anim.stop();
          resetNumbers("23-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Bangladesh  Ca m b o d g e  79% 23%  des filles diplômées poursuivent leur éducation ou trouvent du travail la première année après avoir obtenu leur diplôme  réduction du taux d’abandon scolaire des filles dans l’enseignement secondaire, grâce au soutien de Room to Read  D ÉVELOPPEMENT S OC IAL ET ÉC ONOMIQUE DES FEMMES - 23"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 25-title" style="top:100px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-title-1.png">
        <img class="abs halfScaleR 25-line" style="top:241px;left:-537px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-line-1.png">
        <img class="abs halfScaleR 25-line" style="top:377px;left:-150px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-line-2.png">
        <h1 id="25-no" class="abs fancyCutMediumStretch 25-no" style="top: 357px; left: 96px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 116000, "comma": true}' ></h1>
        <img class="abs halfScale 25-text" style="top:394px;left:86px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-text-1.png">
        <img class="abs halfScale originBC 25-image" style="bottom:519px;left:37px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-image-1.png">
        <h1 id="25-no" class="abs fancyCutMediumStretch 25-no" style="top: 341px; left: 425px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 558, "append": "%"}' ></h1>
        <img class="abs halfScale 25-text" style="top:735px;left:362px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-text-2.png">
        <img class="abs halfScale originBC 25-image" style="bottom:147px;left:307px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-image-2.png">
        <h1 id="25-no" class="abs fancyCutMediumStretch 25-no" style="top: 575px; left: 249px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 135, "append": "%"}' ></h1>
        <img class="abs halfScaleC 25-image" style="top:557px;left:68px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-image-3.png">
        <img class="abs halfScaleC 25-text" style="top:719px;left:48px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-text-3.png">
        <img class="abs halfScaleC 25-text" style="top:768px;left:-76px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-text-4.png">
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim
            .fromTo(cOf("25-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("25-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("25-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("25-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[0])}}, 1.6)
            .fromTo(cOf("25-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("25-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("25-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("25-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[1])}}, 2.35)
            .fromTo(cOf("25-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("25-image")[2], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("25-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("25-no")[2])}}, 2.8)
            .fromTo(cOf("25-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("25-text")[3], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
        }

        function onPageLeave() {
          pg25Anim.stop();
          resetNumbers("25-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "OPPORTUNITÉS ÉCONOMIQUES  116 000  558%  Gh a n a  personnes ont accès à l’eau potable grâce aux 317 femmes formées par Saha Global au Ghana  135% Rwanda  20,84 $  46,20 $  augmentation moyenne des revenus mensuels  20,97 $  138,60 $  augmentation moyenne de l’épargne mensuelle  pour les participantes au programme de Women for Women International au Rwanda, entre 2017 et 2020 24 - DÉ V E LO PP EM EN T SO CIA L ET ÉCO N O MIQUE DES FEMMES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 26-line" style="top:241px;left:-1252px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-line-1.png">
        <img class="abs halfScaleR 26-line" style="top:377px;left:-864px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/25-line-2.png">
        <img class="abs halfScaleR 26-line" style="top:372px;left:-370px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-line-3.png">
        <img class="abs halfScaleR 26-line" style="top:314px;left:348px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-line-4.png">
        <h1 id="26-no" class="abs fancyCutMediumStretch 26-no" style="top: 702px; left: 86px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 253908, "comma": true}' ></h1>
        <h1 id="26-no" class="abs fancyCutMediumStretch 26-no" style="top: 702px; left: 236px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 29, "append": "%"}' ></h1>
        <h1 id="26-no" class="abs fancyCutMediumStretch 26-no" style="top: 756px; left: 526px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 14000, "comma": true, "preppend": "+"}' ></h1>
        <img class="abs halfScale 26-text" style="top:732px;left:72px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-text-1.png">
        <img class="abs halfScale 26-text" style="top:736px;left:229px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-text-2.png">
        <img class="abs halfScale 26-text" style="top:790px;left:518px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-text-3.png">
        <img class="abs halfScaleC 26-image" style="bottom:107px;left:-19px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-image-1.png">
        <img class="abs halfScaleC 26-image" style="bottom:85px;left:220px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-image-2.png">
        <img class="abs halfScaleC 26-image" style="top:550px;left:457px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/26-image-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim
            .fromTo(cOf("26-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("26-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("26-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("26-line")[2], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("26-line")[3], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("26-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("26-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[0])}}, 2.8)
            .fromTo(cOf("26-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("26-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[1])}}, 3.1)
            .fromTo(cOf("26-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.25)
            .fromTo(cOf("26-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.4)
            .fromTo(cOf("26-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.55)
            .fromTo(cOf("26-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("26-no")[2])}}, 3.7)
            .fromTo(cOf("26-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.85)
        }

        function onPageLeave() {
          pg26Anim.stop();
          resetNumbers("26-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "AFRIQUE  Ke n ya Éthiopie  253 908 29%  femmes et enfants soutenus par BOMA  augmentation du revenu des femmes ultra-pauvres vivant dans les zones arides du Kenya grâce au programme de réduction de la pauvreté de BOMA  = 500 entreprises  +14 000 entreprises créées  D ÉVELOPPEMENT S OC IAL ET ÉC ONOMIQUE DES FEMMES - 25"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "26 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": ``,
      "content": `
        <img class="abs halfScale 28-title" style="top:154px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/28-title-1.png">
        <img class="abs halfScale 28-title" style="top:344px;left:331px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/28-text-1.png">
        
        <div class="28-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/Cartier_Sustainable_livelihoods_V4.mp4')" style="top: 275px; left: 563px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim
            .staggerFromTo(cOf("28-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("28-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg28Anim.stop();
          resetNumbers("28-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MODES DE SUBSISTANCE ET ÉCOSYSTÈMES DURABLES Des inégalités sociales profondes et fortement ancrées freinent le développement de sociétés entières. Au cours de ces dix dernières années, nous avons identifié et financé des approches efficaces dans la lutte contre l’extrême pauvreté. En travaillant aux côtés de petits exploitants agricoles, de communautés pastorales et de micro-entrepreneurs, nos partenaires ont contribué à améliorer leur accès aux ressources, aux informations, aux infrastructures et aux marchés, afin qu’ils deviennent plus productifs et plus résilients face à des conditions environnementales toujours plus instables. XXX - 27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 29-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-title-1.png">
        <img class="abs halfScaleR 29-line" style="top:365px;left:-354px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-line-1.png">
        <img class="abs halfScaleC originBC 29-image" style="bottom:452px;left:138px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-image-1.png">
        <img class="abs halfScaleC originBC 29-image" style="bottom:597px;left:66px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-image-2.png">
        <h1 id="29-no" class="abs fancyCutMediumStretch 29-no" style="top: 276px; left: 100px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 66500, "preppend": "+", "comma": true}' ></h1>
        <img class="abs halfScale 29-text" style="top:313px;left:86px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-text-1.png">
        <h1 id="29-no" class="abs fancyCutMediumStretch 29-no" style="top: 393px; left: 95px; font-size: 1.7em; font-weight: 300; color: #1a2942; padding: 0px; margin: 0px;"  data-number='{"to": 45, "append": "%"}' ></h1>
        <img class="abs halfScaleC originBC 29-image" style="bottom:380px;left:-72px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-image-3.png">
        <img class="abs halfScale 29-text" style="top:442px;left:88px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-text-2.png">
        <img class="abs halfScaleC 29-image" style="top:446px;left:-190px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-image-4.png">
      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim
            .fromTo(cOf("29-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("29-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("29-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("29-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("29-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[0])}}, 1.75)
            .fromTo(cOf("29-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("29-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[1])}}, 2.05)
            .fromTo(cOf("29-image")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("29-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("29-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)
        }

        function onPageLeave() {
          pg29Anim.stop();
          resetNumbers("29-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LES CHEMINS POUR SORTIR DE LA PAUVRETÉ +66 500 micro-entreprises créées en Afrique subsaharienne par Village Enterprise et  45% augmentation du revenu annuel moyen des ménages qui ont pris part au programme de réduction de la pauvreté de Village Enterprise  $  $  AFRIQUE SUBSAHARIENNE  28 - MO DE S D E SUBSISTA N CE ET ÉCO SY STÈ MES DURABLES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 30-line" style="top:365px;left:-1068px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/29-line-1.png">
        <img class="abs halfScaleR 30-line" style="top:321px;left:195px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/30-line-2.png">
        <img class="abs halfScaleC originBC 30-image" style="bottom:135px;left:2px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/30-image-1.png">
        <img class="abs halfScaleC originBC 30-image" style="bottom:49px;left:309px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/30-image-2.png">
        <h1 id="30-no" class="abs fancyCutMediumStretch 30-no" style="top: 598px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3042; padding: 0px; margin: 0px;"  data-number='{"to": 900, "append": "%", "comma": true}' ></h1>
        <img class="abs halfScale 30-text" style="top:631px;left:109px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/30-text-1.png">
        <h1 id="30-no" class="abs fancyCutMediumStretch 30-no" style="top: 687px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3042; padding: 0px; margin: 0px;"  data-number='{"to": 37, "append": "%"}' ></h1>
        <img class="abs halfScale 30-text" style="top:720px;left:108px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/30-text-2.png">
      `,
      "script": `
        function onPageEnter() {
          pg30Anim = new TimelineMax();
          pg30Anim
            .fromTo(cOf("30-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("30-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("30-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("30-no")[0])}}, 1.75)
            .fromTo(cOf("30-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("30-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("30-image")[0], 0.6, {x: 30, opacity: 0}, {x: 0, opacity: 1, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("30-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("30-no")[1])}}, 2.35)
            .fromTo(cOf("30-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
        }

        function onPageLeave() {
          pg30Anim.stop();
          resetNumbers("30-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "900  AFRIQUE  800  700  600  500  400  900%  300  augmentation de l’épargne  37%  200  $  $  O u g a nd a  augmentation des revenus chez les participants au programme de formation des ultra-pauvres de BRAC au Bangladesh, qui est maintenant adapté aux personnes handicapées en Ouganda  100  0  MODES DE S UBS IS TANC E ET ÉC OS YS T ÈMES DURABLES - 29"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 31-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-title-1.png">

        <img class="abs halfScaleR 31-line" style="top:196px;left:-64px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-line-1.png">
        <img class="abs halfScaleR 31-line" style="top:508px;left:-233px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-line-2.png">

        <img class="abs halfScaleC 31-image" style="bottom:370px;left:294px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-image-1.png">
        <img class="abs halfScaleC originBC 31-image" style="bottom:497px;left:23px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-image-2.png">
        <img class="abs halfScaleC originBC 31-image" style="bottom:49px;left:33px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-image-3.png">
        <img class="abs halfScaleC 31-image" style="bottom:-157px;left:359px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-image-4.png">

        <img class="abs halfScale 31-text" style="top:237px;left:215px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-text-1.png">
        <img class="abs halfScale 31-text" style="top:337px;left:507px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-text-2.png">
        <img class="abs halfScale 31-text" style="top:648px;left:219px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-text-3.png">

        <h1 id="31-no" class="abs fancyCutMediumStretch 31-no" style="top: 202px; left: 224px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;"  data-number='{"to": 221, "append": "%", "comma": true}' ></h1>
        <h1 id="31-no" class="abs fancyCutMediumStretch 31-no" style="top: 614px; left: 225px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;"  data-number='{"to": 20, "append": " –"}' ></h1>
        <h1 id="31-no" class="abs fancyCutMediumStretch 31-no" style="top: 614px; left: 299px; font-size: 1.7em; font-weight: 300; color: #1a3142; padding: 0px; margin: 0px;"  data-number='{"to": 25, "append": "%"}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim
            .fromTo(cOf("31-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("31-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("31-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.45)
            .fromTo(cOf("31-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("31-image")[1], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("31-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[0])}}, 1.9)
            .fromTo(cOf("31-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("31-line")[1], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("31-image")[2], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("31-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[1])}}, 2.65)
            .fromTo(cOf("31-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("31-no")[2])}}, 2.8)
            .fromTo(cOf("31-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("31-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.25)
        }

        function onPageLeave() {
          pg31Anim.stop();
          resetNumbers("31-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DES PETITS AGRICULTEURS PLUS FORTS 221%  nourriture supplémentaire produite en 2021 par les agriculteurs soutenus par myAgro  0%  100  Sé n é g a l  $  100 50$  5  Pé rou  35 30 25 20 15 10 5 0  20−25%  croissance annuelle des petites entreprises agricoles soutenues par Root Capital, ce qui a permis d’améliorer les moyens de subsistance des milliers de petits fermiers qui les approvisionnent  30 - MO DE S D E SUBSISTA N CE ET ÉCO SY STÈ MES DURABLES  $  $  255 dollars de gain supplémentaire par agriculteur, soit une augmentation de 46% du revenu moyen"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 32-line" style="top:197px;left:-779px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/31-line-1.png">
        <img class="abs halfScaleR 32-line" style="top:176px;left:221px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-line-3.png">
        
        <img class="abs halfScaleC 32-image" style="bottom:239px;left:-7px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-image-1.png">
        <img class="abs halfScaleC originBC 32-image" style="bottom:65px;left:204px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-image-2.png">
        <img class="abs halfScaleC originBC 32-image" style="bottom:39px;left:375px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-image-3.png">
        <img class="abs halfScaleC 32-image" style="bottom:27px;left:472px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-image-4.png">

        <img class="abs halfScaleR 32-line" style="top:306px;left:-160px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-line-2.png">

        <img class="abs halfScale 32-text" style="top:661px;left:94px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-text-1.png">
        <img class="abs halfScale 32-text" style="top:773px;left:94px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-text-2.png">
        <img class="abs halfScale 32-text" style="top:519px;left:429px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/32-text-3.png">

        <h1 id="32-no" class="abs fancyCutMediumStretch 32-no" style="top: 486px; left: 442px; font-size: 1.7em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;"  data-number='{"to": 250000, "comma": true}' ></h1>
        <h1 id="32-no" class="abs fancyCutMediumStretch 32-no" style="top: 626px; left: 109px; font-size: 1.7em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;"  data-number='{"to": 631800, "comma": true}' ></h1>
        <h1 id="32-no" class="abs fancyCutMediumStretch 32-no" style="top: 769px; left: 95px; font-size: 1em; font-weight: 300; color: #1a3242; padding: 0px; margin: 0px;"  data-number='{"to": 47, "append": "%"}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim
            .fromTo(cOf("32-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("32-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("32-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("32-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[0])}}, 1.75)
            .fromTo(cOf("32-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("32-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("32-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("32-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("32-line")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("32-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[1])}}, 2.8)
            .fromTo(cOf("32-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("32-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("32-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.25)
            .fromTo(cOf("32-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[2])}}, 2.8)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Myanmar  250 000  familles de petits agriculteurs aidées chaque année par Proximity Designs, ce qui a permis un gain net annuel de 300 $ par fermier  Rwanda  631 800  fermiers rwandais ont augmenté leurs revenus de 115 $ en moyenne grâce au soutien de 100 One Acre Fund 10 5  47% augmentation du revenu moyen des agriculteurs soutenus  100 100 100  $  $  $ $ $  $  MODES DE S UBS IS TANC E ET ÉC OS YS T ÈMES DURABLES - 31"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 33-title" style="top:100px;left:90px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-title-1.png">

        <img class="abs halfScaleC 33-image" style="bottom:178px;left:-193px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-image-1.png">
        <img class="abs halfScaleR 33-line" style="top:422px;left:-244px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-line-1.png">

        <img class="abs halfScaleC  33-image" style="bottom:-82px;left:-72px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-image-2.png">
        <img class="abs halfScaleC originBC 33-image" style="bottom:126px;left:250px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-image-3.png">

        <img class="abs halfScale 33-text" style="top:704px;left:382px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-text-1.png">

        <h1 id="33-no" class="abs fancyCutMediumStretch 33-no" style="top: 649px; left: 390px; font-size: 1.9em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 23, "append": "%", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim
            .fromTo(cOf("33-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("33-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("33-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("33-image")[1], 0.6, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("33-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("33-no")[0])}}, 1.9)
            .fromTo(cOf("33-image")[2], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("33-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "EQUIPÉS POUR PROSPÉRER  Zambie  23% augmentation du revenu des producteurs laitiers de Zambie équipés d’un vélo Buffalo de World Bicycle Relief 32 - MO DE S D E SUBSISTA N CE ET ÉCO SY STÈ MES DURABLES  $  $"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleR 34-line" style="top:422px;left:-958px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/33-line-1.png">
        <img class="abs halfScaleR 34-line" style="top:187px;left:276px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/34-line-2.png">

        <img class="abs halfScaleC originBC 34-image" style="bottom:49px;left:178px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/34-image-1.png">
        <img class="abs halfScaleC 34-image" style="bottom:-114px;left:170px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/34-image-2.png">

        <img class="abs halfScale 34-text" style="top:572px;left:70px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/34-text-1.png">
        <img class="abs halfScale 34-text" style="top:719px;left:70px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/34-text-2.png">

        <h1 id="34-no" class="abs fancyCutMediumStretch 34-no" style="top: 538px; left: 78px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 1.9, "append": "M", "decimals": 1}' ></h1>
        <h1 id="34-no" class="abs fancyCutMediumStretch 34-no" style="top: 688px; left: 77px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 22, "append": " –", "comma": true}' ></h1>
        <h1 id="34-no" class="abs fancyCutMediumStretch 34-no" style="top: 688px; left: 151px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 32, "append": "%", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim
            .fromTo(cOf("34-line")[0], 0.6, {opacity:0, x: -60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("34-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("34-image")[1], 0.6, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("34-image")[0], 0.6, {scaleY: 0}, {scaleY:0.5, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("34-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[0])}}, 2.35)
            .fromTo(cOf("34-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("34-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[1])}}, 2.65)
            .fromTo(cOf("34-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[2])}}, 2.8)
            .fromTo(cOf("34-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("33-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "B a ng l a d e s h  1,9M  Bangladais qui disposent de bas revenus ont reçu de VisionSpring des lunettes de lecture 35 depuis 2006  22−32%  30 25  augmentation de 20 la productivité chez 15 les personnes ayant 10 reçu des lunettes 5 de VisionSpring, démontrée en Inde 0 MODES DE S UBS IS TANC E ET ÉC OS YS T ÈMES DURABLES - 33"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "34 - X X X"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": ``,
      "content": `
        <img class="abs halfScale 36-title" style="top:318px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/36-title-1.png">
        <img class="abs halfScale 36-title" style="top:479px;left:332px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/36-text-1.png">
        <div class="36-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/Cartier_Philanthropy_Emergency_Response-V12_W_SUBS.mp4')" style="top: 403px; left: 583px; filter: invert(1);">
          <img class="abs halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim
            .staggerFromTo(cOf("36-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("36-play"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, "-=0.3")
        }

        function onPageLeave() {
          pg36Anim.stop();
          resetNumbers("36-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "RÉPONSE AUX SITUATIONS D’URGENCE Une réponse efficace et opportune aux situations d’urgence peut sauver des vies, soulager les souffrances et protéger les moyens de subsistance. Au cours de la dernière décennie, nos partenaires ont répondu aux crises les plus sévères, s’engageant toujours à restaurer la dignité et à réduire la vulnérabilité des personnes les plus démunies, qui souvent souffrent dans le silence et l’indifférence. XXX - 35"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 37-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-title-1.png">

        <img class="abs halfScaleC 37-image" style="bottom:303px;left:-36px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-image-1.png">
        
        <img class="abs halfScaleR 37-line" style="top:638px;left:-441px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-line-1.png">
        <img class="abs halfScaleR 37-line" style="top:436px;left:-621px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-line-2.png">

        <img class="abs halfScale 37-text" style="top:497px;left:115px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-text-1.png">
        <img class="abs halfScale 37-text" style="top:361px;left:320px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-text-2.png">

        <h1 id="37-no" class="abs fancyCutMediumStretch 37-no" style="top: 465px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 8, "append": "", "comma": true}' ></h1>
        <h1 id="37-no" class="abs fancyCutMediumStretch 37-no" style="top: 328px; left: 330px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 34500, "preppend": "+", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim
            .fromTo(cOf("37-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("37-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("37-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("37-no")[0])}}, 1.6)
            .fromTo(cOf("37-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("37-no")[1])}}, 1.9)
            .fromTo(cOf("37-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.75)
            .fromTo(cOf("37-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("37-line")[0], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("37-line")[1], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg37Anim.stop();
          resetNumbers("37-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "MIGRATION ET DÉPLACEMENTS  +34 500  survivants secourus en Méditerranée centrale depuis 2016 grâce à SOS Méditerranée  8  camps de réfugiés démantelés en Haïti entre 2013 et 2017 grâce à CARE qui a permis aux personnes de trouver un endroit adéquat pour vivre  2012  2013  36 - RÉ P O N S E A UX SITUATIO N S D ’ UR GEN CE  2014  2015  2016  2017"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 38-image" style="bottom:452px;left:-15px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-image-1.png">
        <img class="abs halfScaleC 38-image" style="bottom:527px;left:306px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-image-2.png">
        <img class="abs halfScaleC 38-image" style="bottom:179px;left:270px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-image-3.png">
        <img class="abs halfScaleC 38-image" style="bottom:425px;left:422px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-image-4.png">
        <img class="abs halfScaleC 38-image" style="bottom:334px;left:452px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-image-5.png">
        
        <img class="abs halfScaleR 38-line" style="top:436px;left:-1335px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/37-line-2.png">
        <img class="abs halfScaleR 38-line" style="top:177px;left:-150px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-line-1.png">
        <img class="abs halfScaleR 38-line" style="top:313px;left:231px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-line-2.png">
        <img class="abs halfScaleR 38-line" style="top:619px;left:423px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-line-3.png">

        <img class="abs halfScale 38-text" style="top:390px;left:69px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-text-1.png">
        <img class="abs halfScale 38-text" style="top:340px;left:336px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-text-2.png">
        <img class="abs halfScale 38-text" style="top:524px;left:496px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/38-text-3.png">

        <h1 id="38-no" class="abs fancyCutMediumStretch 38-no" style="top: 356px; left: 118px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 340000, "append": "", "comma": true}' ></h1>
        <h1 id="38-no" class="abs fancyCutMediumStretch 38-no" style="top: 306px; left: 347px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 10000, "preppend": "+", "comma": true}' ></h1>
        <h1 id="38-no" class="abs fancyCutMediumStretch 38-no" style="top: 486px; left: 509px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 200000, "append": "", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg38Anim = new TimelineMax();
          pg38Anim
            .fromTo(cOf("38-line")[0], 0.6, {opacity:0, x: 60}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("38-line")[1], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.2)
            .fromTo(cOf("38-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.35)
            .fromTo(cOf("38-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[0])}}, 2.5)
            .fromTo(cOf("38-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("38-line")[2], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("38-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.65)
            .fromTo(cOf("38-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[1])}}, 2.8)
            .fromTo(cOf("38-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("38-image")[2], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("38-line")[3], 0.6, {opacity:0, y: 60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("38-image")[3], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.95)
            .fromTo(cOf("38-image")[4], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("38-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("38-no")[2])}}, 3.25)
            .fromTo(cOf("38-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.4)
        }

        function onPageLeave() {
          pg38Anim.stop();
          resetNumbers("38-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+10 000  Afghans ont pris un nouveau départ aux États-Unis avec l’aide de l’International Rescue Committee  340 000  réfugiés Rohingyas ont bénéficié de services de santé de qualité à Cox’s Bazar grâce à Médecins Sans Frontières en 2018 et à BRAC en 2019 et 2020  2018  2019  200 000 personnes assistées en Ukraine et hors des frontières par Medair  2020  2021  2022  RÉPONS E AUX S IT UAT IONS D’URG ENC E - 37"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 39-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/39-title-1.png">
        <img class="abs halfScale 39-title" style="top:552px;left:242px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/39-text-1.png">
        <img class="abs halfScale 39-title" style="top:717px;left:406px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/39-text-2.png">

        <img class="abs halfScaleC 39-image" style="bottom:359px;left:203px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/39-image-1.png">
        <img class="abs halfScaleC 39-image" style="bottom:254px;left:35px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/39-image-2.png">
        <img class="abs halfScaleC 39-image" style="bottom:103px;left:144px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/39-image-3.png">
        
        <h1 id="39-no" class="abs fancyCutMediumStretch 39-no" style="top: 485px; left: 260px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 4.3, "append": "M", "decimals": 1}' ></h1>
        <h1 id="39-no" class="abs fancyCutMediumStretch 39-no" style="top: 648px; left: 412px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 21, "preppend": "", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim
            .fromTo(cOf("39-title")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .staggerFromTo(cOf("39-image"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 0.3, 1.3)
            .fromTo(cOf("39-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("39-no")[0])}}, 1.75)
            .fromTo(cOf("39-title")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("39-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("39-no")[1])}}, 2.05)
            .fromTo(cOf("39-title")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.2)
        }

        function onPageLeave() {
          pg39Anim.stop();
          resetNumbers("39-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "PANDÉMIE DE CORONAVIRUS 2020-2022  4,3M  D E F RA NCS S UI S S E S  21  PAY S  38 - RÉ P O N S E A UX SITUATIO N S D ’ UR GEN CE"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 40-title" style="top:698px;left:244px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/40-text-1.png">

        <img class="abs halfScaleC 40-image" style="bottom:515px;left:-27px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/40-image-1.png">
        <img class="abs halfScaleC 40-image" style="bottom:457px;left:172px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/40-image-2.png">
        <img class="abs halfScaleC 40-image" style="bottom:277px;left:-7px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/40-image-3.png">
        <img class="abs halfScaleC 40-image" style="bottom:233px;left:194px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/40-image-4.png">
        <img class="abs halfScaleC 40-image" style="bottom:93px;left:39px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/40-image-5.png">
        
        <h1 id="40-no" class="abs fancyCutMediumStretch 40-no" style="top: 628px; left: 252px; font-size: 3.6em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 20, "preppend": "", "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim
            .staggerFromTo(cOf("40-image"), 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 0.3, 1.3)
            .fromTo(cOf("40-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("40-no")[0])}}, 2.65)
            .fromTo(cOf("40-title")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
        }

        function onPageLeave() {
          pg40Anim.stop();
          resetNumbers("40-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "20  O R GA NI S ATI ONS  RÉPONS E AUX S IT UAT IONS D’URG ENC E - 39"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `
        <div class="abs" style="top: 478px; left: 555px; width: 25px; height: 24px; background: white;"></div>

        <img class="abs halfScale 41-title" style="top:105px;left:89px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/41-title-1.png">

        <img class="abs halfScaleC 41-image" style="bottom:576px;left:397px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/41-image-1.png">
        <img class="abs halfScaleC 41-image" style="bottom:35px;left:367px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/41-image-2.png">
        
        <img class="abs halfScaleR 41-line" style="top:372px;left:-12px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/41-line-1.png">
        <img class="abs halfScaleR 41-line" style="top:315px;left:99px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/41-line-2.png">

        <img class="abs halfScale 41-text" style="top:402px;left:88px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/41-text-1.png">

        <h1 id="41-no" class="abs fancyCutMediumStretch 41-no" style="top: 369px; left: 103px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 200000, "comma": true}' ></h1>
        <h1 id="41-no" class="abs fancyCutMediumStretch 41-no" style="top: 270px; left: 426px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 2.8, "append": "M", "decimals": 1}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim
            .fromTo(cOf("41-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("41-line")[0], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.3)
            .fromTo(cOf("41-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("41-no")[0])}}, 1.45)
            .fromTo(cOf("41-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
            .fromTo(cOf("41-line")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.9)
            .fromTo(cOf("41-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.05)
            .fromTo(cOf("41-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("41-no")[1])}}, 2.2)
            .fromTo(cOf("41-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 2.35)
        }

        function onPageLeave() {
          pg41Anim.stop();
          resetNumbers("41-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "CATASTROPHES NATURELLES 2,8M 200 000  Népalais ont reçu de la nourriture de la Fédération internationale de la Croix-Rouge après le séisme de 2015  Philippins ont bénéficié d’eau potable et d’installations sanitaires grâce à Action contre la Faim après le passage du typhon Haiyan  2012  2013  40 - RÉ P O N S E A UX SITUATIO N S D ’ UR GEN CE  2014  2015  2016  2017"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScaleC 42-image" style="bottom:578px;left:41px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-image-1.png">
        <img class="abs halfScaleC 42-image" style="bottom:419px;left:316px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-image-2.png">
        
        <img class="abs halfScaleR 42-line" style="top:215px;left:-195px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-line-1.png">
        <img class="abs halfScaleR 42-line" style="top:126px;left:229px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-line-2.png">
        <img class="abs halfScaleR 42-line" style="top:313px;left:360px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-line-3.png">

        <img class="abs halfScale 42-text" style="top:247px;left:119px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-text-1.png">
        <img class="abs halfScale 42-text" style="top:460px;left:119px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-text-2.png">
        <img class="abs halfScale 42-text" style="top:163px;left:335px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-text-3.png">
        <img class="abs halfScale 42-text" style="top:434px;left:407px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-text-4.png">
        <img class="abs halfScale 42-text" style="top:602px;left:408px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/42-text-5.png">

        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 214px; left: 132px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 20900, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 427px; left: 132px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 127500, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 128px; left: 348px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 50000, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 397px; left: 418px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 10000, "comma": true}' ></h1>
        <h1 id="42-no" class="abs fancyCutMediumStretch 42-no" style="top: 569px; left: 418px; font-size: 1.7em; font-weight: 300; color: #1a3342; padding: 0px; margin: 0px;"  data-number='{"to": 2000, "comma": true}' ></h1>
      `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim
            .fromTo(cOf("42-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
            .fromTo(cOf("42-line")[0], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.5)
            .fromTo(cOf("42-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[0])}}, 2.65)
            .fromTo(cOf("42-text")[0], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.8)
            .fromTo(cOf("42-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[1])}}, 2.95)
            .fromTo(cOf("42-text")[1], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.1)
            .fromTo(cOf("42-line")[1], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 3.4)
            .fromTo(cOf("42-image")[0], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 3.55)
            .fromTo(cOf("42-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[2])}}, 3.7)
            .fromTo(cOf("42-text")[2], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 3.85)
            .fromTo(cOf("42-line")[2], 0.6, {opacity:0, y: -60}, {opacity: 1, y: 0, ease: Power2.easeOut}, 4.15)
            .fromTo(cOf("42-image")[1], 0.6, {scale: 0}, {scale:0.5, ease: Power2.easeOut}, 4.3)
            .fromTo(cOf("42-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[3])}}, 4.45)
            .fromTo(cOf("42-text")[3], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.6)
            .fromTo(cOf("42-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("42-no")[4])}}, 4.75)
            .fromTo(cOf("42-text")[4], 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 4.9)
        }

        function onPageLeave() {
          pg42Anim.stop();
          resetNumbers("42-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "50 000 20 900  enfants traités par le programme d’alimentation ambulatoire de Médecins Sans Frontières dans l’unité pédiatrique de l’hôpital de Magaria, au Niger  127 500  enfants de moins de cinq ans examinés pour détecter et traiter la malnutrition  familles ont bénéficié d’une aide d’urgence et de différentes mesures de redressement mises en place par BRAC après des inondations sans précédent  10 000  personnes ont reçu une aide alimentaire d’urgence par Medair dans le district de Beloha, à Madagascar  2 000  enfants de moins de cinq ans examinés pour détecter de la malnutrition  = 100 enfants de moins de cinq ans  2018  2019  2020  2021  2022  RÉPONS E AUX S IT UAT IONS D’URG ENC E - 41"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "42 - A XX CCE X S S TO B A SIC SER VICES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 44-title" style="top:150px;left:333px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-title-1.png">
        <img class="abs halfScale 44-title" style="top:318px;left:333px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-title-2.png">
        <img class="abs halfScale 44-title" style="top:424px;left:355px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-text-1.png">
        <img class="abs halfScale 44-title" style="top:474px;left:356px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-text-2.png">
        <img class="abs halfScale 44-title" style="top:548px;left:356px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-text-3.png">
        <img class="abs halfScale 44-title" style="top:674px;left:356px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-text-4.png">
        <img class="abs halfScale 44-title" style="top:768px;left:356px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/44-text-5.png">

        <div class="contentLinkNone" onclick="Publish.goToPage(44);" style="top: 419px; left: 351px; width: 305px; height: 24px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(46);" style="top: 473px; left: 351px; width: 305px; height: 41px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(48);" style="top: 545px; left: 351px; width: 305px; height: 97px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(50);" style="top: 673px; left: 351px; width: 305px; height: 49px;"></div>
        <div class="contentLinkNone" onclick="Publish.goToPage(52);" style="top: 764px; left: 351px; width: 305px; height: 59px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg44Anim = new TimelineMax();
          pg44Anim
            .staggerFromTo(cOf("44-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg44Anim.stop();
          resetNumbers("43-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "LES CINQ LEÇONS TIRÉES D’UNE DÉCENNIE D’ENGAGEMENT 1.  FINANCER L’IMPACT 2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION 3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX 4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR 5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS XXX - 43"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 45-title" style="top:664px;left:84px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/45-title-1.png">
        <img class="abs halfScale 45-title" style="top:720px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/45-text-1.png">
        <img class="abs halfScale 45-title" style="top:759px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/45-text-2.png">

        <h1 id="45-no" class="abs fancyCutBold 45-no" style="top: 384px; left: 548px; font-size: 2.1em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 40, "append": "%"}' ></h1>
        <h1 id="45-no" class="abs fancyCutBold 45-no" style="top: 415px; left: 556px; font-size: 2.1em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 0.8, "append": "%", "decimals": 1}' ></h1>

        <div class="contentLinkNone abs" style="top: 660px; left: 79px; width: 565px; height: 165px;" onclick="Publish.openArticle(2)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim
            .staggerFromTo(cOf("45-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("45-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("45-no")[0])}}, 1.3)
            .fromTo(cOf("45-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("45-no")[1])}}, 1.6)
        }

        function onPageLeave() {
          pg45Anim.stop();
          resetNumbers("45-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Réduction du taux de transmission du VIH de la mère à l’enfant de  40% à 0,8%  1. FINANCER L’IMPACT Il y a tant à faire aujourd’hui - et les besoins sont si urgents - que nous ne pouvons pas nous permettre de gaspiller de l’argent, du temps ou de l’énergie sur des programmes qui ne fonctionnent pas. Notre première responsabilité, en tant que bailleur, est de nous assurer que chaque dollar investi apporte un changement positif, concret et tangible dans la vie des personnes pour lesquelles nous nous engageons. Pour ce faire, nous devons soutenir des solutions éprouvées, étayées par des données probantes, et qui auront des résultats impactants. 44 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `
        <h1 id="46-no" class="abs fancyCutBold 46-no" style="top: 211px; left: 550px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 75, "append": "%"}' ></h1>
        <div class="contentLinkNone abs" style="    top: 406px; left: 62px; width: 569px; height: 418px;" onclick="Publish.openArticle(2)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg46Anim = new TimelineMax();
          pg46Anim
            .fromTo(cOf("46-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("46-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg46Anim.stop();
          resetNumbers("46-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "75%  des élèves sont toujours scolarisés six ans plus tard  mothers2mothers  The Luminos Fund  mothers2mothers (m2m) emploie des femmes vivant avec le VIH-SIDA afin qu’elles facilitent l’accès d’autres femmes et de leur famille aux services essentiels et aux soins de santé. Le programme se concentre sur la réduction du risque d’infection au VIH et aux maladies associées. Depuis 2017, notre soutien a permis à m2m de déployer ses services de santé intégrée en Ouganda pour réduire la transmission du virus des femmes enceintes et séropositives à leur bébé et pour préserver plus en général la santé des femmes et des enfants.  Le programme d’apprentissage accéléré de Luminos Fund, « Seconde Chance », a déjà permis à plus de 152 000 enfants africains, qui n’ont jamais été scolarisés ou qui ont dû interrompre leur éducation à cause de la pauvreté, d’un conflit ou de la discrimination, de retrouver les bancs de l’école. Depuis 2018, nous soutenons l’expansion rapide du programme dans les régions reculées d’Afar et d’Oromia, en Éthiopie.  Pays : Ouganda Financé depuis 2017  Pays : Éthiopie Financé depuis 2018  Au cours de ces vingt dernières années, les efforts de m2m ont permis l’élimination presque totale de la transmission du virus de la mère à l’enfant parmi les femmes encadrées par son programme : en Afrique orientale et australe, le taux de transmission du VIH de ces femmes à leur enfant est passé de 40 % à 0,8 % et la mortalité infantile a été abaissée à deux décès pour 1 000 naissances.  Parmi les 26 850 élèves inscrits dans les classes de « Seconde Chance », entre 2018 et 2021, 91 % à 97 % d’entre eux ont réussi leur transition vers des écoles publiques et poursuivent leur éducation. Quelque 9 000 enfants supplémentaires ont bénéficié du programme mis en œuvre directement par le gouvernement. Six ans plus tard, 75 % des élèves de « Seconde Chance » sont toujours scolarisés.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 45"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 47-title" style="top:590px;left:84px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/47-title-1.png">
        <img class="abs halfScale 47-title" style="top:691px;left:85px;transform:scale(0.525)" src="/a-decade-of-effective-philanthropy/fr/static/_content/47-text-1.png">
        <div class="contentLinkNone abs" style="top: 592px; left: 79px; width: 594px; height: 236px;" onclick="Publish.openArticle(3)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim
            .staggerFromTo(cOf("47-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg47Anim.stop();
          resetNumbers("47-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION Nous travaillons sur des questions très complexes et multidimensionnelles et, à ce titre, nous ne nous attendons pas à des résultats immédiats, d’un jour à l’autre. Notre engagement se fait sur le long terme. Soutenir des projets sur deux ou trois ans seulement reviendrait à choisir une approche de type « cases à cocher ». Nous avons fait le choix d’investir sur le long terme et sur la création d’alliances solides, en aidant nos partenaires à se développer, à renforcer leur impact et à élargir le champ de leurs opérations. Fournir un financement sans restriction, que les organisations à but non lucratif gèrent comme elles l’entendent, est sûrement la mesure la plus transformatrice que nous puissions prendre pour véritablement les aider à atteindre leurs objectifs. 46 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `
        <h1 id="48-no" class="abs fancyCutBold 48-no" style="top: 261px; left: 563px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 2.8, "preppend": "+", "append": "M", "decimals": 1}' ></h1>
        <div class="contentLinkNone abs" style="    top: 395px; left: 62px; width: 569px; height: 429px;" onclick="Publish.openArticle(3)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim
            .fromTo(cOf("48-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("48-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg48Anim.stop();
          resetNumbers("48-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+2,8M filles soutenues dans le monde  Educate Girls  Room to Read  Pays : Inde Financé depuis 2014  Pays : Bangladesh, Cambodge, sans restriction Financé depuis 2019  Educate Girls s’attaque aux inégalités entre les sexes et aux barrières qui empêchent les filles d’aller à l’école dans les villages ruraux les plus isolés de l’Inde. Partant d’un projet pilote portant sur 50 écoles en 2007, Educate Girls couvre aujourd’hui plus de 20 000 villages au Rajasthan, au Madhya Pradesh et en Uttar Pradesh. Au fil des ans, Educate Girls a obtenu des résultats impressionnants en matière d’inscription, de rétention et d’apprentissage. Les visites à domicile et la sensibilisation des communautés sont au cœur de son succès. Educate Girls exploite également les ressources gouvernementales pour améliorer les infrastructures, la gouvernance et l’enseignement des écoles publiques. Nous finançons l’approche unique d’Educate Girls depuis 2014, contribuant à la scolarisation de plus de 1,1 million de filles. Aujourd’hui, nous soutenons l’organisation pour qu’elle touche 1,5 million de filles d’ici 2024.  Room to Read cherche à transformer la vie de millions d’enfants vivant dans des communautés à faible revenu en se concentrant sur l’alphabétisation et l’égalité des genres dans l’éducation. En collaborant avec les communautés locales, les gouvernements et des organisations partenaires, Room to Read développe l’alphabétisation et inculque l’habitude de la lecture aux enfants des écoles primaires. Depuis 2019, nous soutenons son Programme d’éducation pour les filles au Bangladesh et au Cambodge, permettant aux adolescentes d’acquérir et de mettre en pratique - par des cours, des ateliers et des activités extrascolaires des connaissances et des compétences de vie afin qu’elles puissent poursuivre leurs études et prendre des décisions éclairées pour leur futur. Depuis juillet 2022, nous offrons à l’organisation un soutien financier sans restriction.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 47"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 49-title" style="top:517px;left:84px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/49-title-1.png">
        <img class="abs halfScale 49-title" style="top:743px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/49-text-1.png">

        <h1 id="49-no" class="abs fancyCutBold 49-no" style="top: 364px; left: 507px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 160000, "comma": true}' ></h1>
        <div class="contentLinkNone abs" style="top: 509px; left: 79px; width: 578px; height: 317px;" onclick="Publish.openArticle(4)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim
            .staggerFromTo(cOf("49-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("49-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("49-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg49Anim.stop();
          resetNumbers("49-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "160 000 femmes souffrant de dépression traitées en Ouganda et en Zambie  3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX Au vu de l’urgence et de l’intensité des problèmes sociaux actuels, si l’ensemble de la communauté philanthropique est séduite par l’innovation et se concentre uniquement sur celle-ci, nous ne serons jamais en mesure de rendre accessibles au plus grand nombre les solutions qui fonctionnent déjà. En d’autres termes, nous n’avons pas besoin d’un million d’innovations, mais d’une seule qui fonctionne, répliquée un million de fois, afin que son impact soit à la hauteur des besoins. 48 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": `
        <h1 id="50-no" class="abs fancyCutBold 50-no" style="top: 139px; left: 279px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 38, "append": "%"}' ></h1>
        <div class="contentLinkNone abs" style="    top: 477px; left: 62px; width: 569px; height: 346px;" onclick="Publish.openArticle(4)"></div>
        <div class="contentLinkNone abs" style="top: 274px; left: 62px; width: 289px; height: 203px;" onclick="Publish.openArticle(4)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg50Anim = new TimelineMax();
          pg50Anim
            .fromTo(cOf("50-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("50-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg50Anim.stop();
          resetNumbers("50-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "38%  réduction de la morbidité des élèves dans les écoles  StrongMinds  Pays : Ouganda, Zambie Financé depuis 2018  L’OMS promeut les thérapies de groupe en tant qu’intervention de santé mentale de première ligne pour les populations vulnérables. StrongMinds est la seule organisation à mettre en œuvre cette solution efficace pour lutter contre la dépression en Afrique. StrongMinds forme et supervise des agents communautaires pour qu’ils deviennent des animateurs en santé mentale chargés d’encadrer des groupes de parole. Ces thérapies ciblent les femmes souffrant de dépression au sein des communautés défavorisées, où la prévalence de la dépression, avec un taux affichant 25 %, est très présente. Des groupes de 10 à 15 femmes se réunissent pour des séances hebdomadaires de 90 minutes, où elles apprennent à identifier les déclencheurs de la dépression, elles partagent des stratégies permettant de combattre les symptômes et, à plus long terme, elles apprennent à devenir plus résilientes. StrongMinds permet ensuite aux femmes arrivées au terme du programme de se former pour encadrer leurs propres groupes de parole, ce qui amplifie l’impact du programme sur le long terme. Nous soutenons StrongMinds depuis 2018 afin que l’organisation développe en Zambie le modèle mis en place en Ouganda. L’organisation est désormais devenue conseillère technique du ministère zambien de la Santé en matière de santé mentale.  Healthy Learners Pays : Zambie Financé depuis 2019  Healthy Learners s’engage à améliorer la santé des enfants de plus de cinq ans grâce à son programme de santé communautaire en milieu scolaire. L’organisation forme les enseignants à reconnaître les symptômes des maladies courantes chez les élèves et à leur prodiguer les soins de base ou à les référer à des centres de santé. Plus vite l’enfant malade est identifié et soigné, plus vite il reprendra l’école. Depuis le début de notre collaboration en 2019, Healthy Learners a systématisé son programme et renforcé sa collaboration avec les ministères zambiens de la Santé et de l’Éducation pour inscrire ce dispositif dans la stratégie nationale de santé scolaire.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 49"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 51-title" style="top:505px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/51-title-1.png">
        <img class="abs halfScale 51-title" style="top:646px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/51-text-1.png">
        <div class="contentLinkNone abs" style="    top: 501px; left: 79px; width: 575px; height: 327px;" onclick="Publish.openArticle(5)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg51Anim = new TimelineMax();
          pg51Anim
            .staggerFromTo(cOf("51-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg51Anim.stop();
          resetNumbers("51-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR Lorsqu’il est question de modifier ou d’améliorer les pratiques philanthropiques, la responsabilité incombe aux bailleurs. La dynamique du pouvoir exige que les bailleurs eux-mêmes remettent en question la nature de leurs relations avec les organisations financées. Il faut donc avant tout reconnaître l’existence d’un déséquilibre de pouvoir qui peut empêcher, s’il n’est pas assumé, une collaboration honnête et fructueuse. Nos partenaires attendent de nous que nous soyons flexibles, pragmatiques, à l’écoute de leurs besoins et de leurs difficultés et prêts à amplifier et à faire connaître leur travail. Mais avant toute chose, ils ont besoin de notre confiance. Ces dernières années, nous avons intentionnellement créé des occasions d’échanges avec nos partenaires afin qu’ils puissent librement exprimer leurs doutes, remettre en question nos demandes ou exposer les changements de stratégie envisagés. Favoriser ainsi le dialogue a permis d’établir des relations de confiance, qui sont à la base des progrès réalisés ensemble. 50 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `
        <h1 id="52-no" class="abs fancyCutBold 52-no" style="top: 87px; left: 267px; font-size: 2.3em; font-weight: 300; color: #052e89; padding: 0px; margin: 0px;"  data-number='{"to": 9000, "preppend": "+", "comma": true}' ></h1>
        <div class="contentLinkNone abs" style="top: 375px; left: 62px; width: 569px; height: 452px;" onclick="Publish.openArticle(5)"></div>
        <div class="contentLinkNone abs" style="    top: 209px; left: 352px; width: 289px; height: 167px;" onclick="Publish.openArticle(5)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg52Anim = new TimelineMax();
          pg52Anim
            .fromTo(cOf("52-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("52-no")[0])}}, 1.3)
        }

        function onPageLeave() {
          pg52Anim.stop();
          resetNumbers("52-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "+9 000 communautés engagées à mettre fin au mariage des enfants  Tostan  Pays : Gambie, Guinéee-Bissau et Sénégal Financé depuis 2016  Village Enterprise Pays : Ouganda Financé depuis 2016  Le programme de formation de Village Enterprise vient en aide aux personnes vivant dans l’extrême pauvreté, en leur permettant de développer des moyens de subsistance durables. L’organisation fournit aux participants une aide financière, une formation en entrepreneuriat et en finance, ainsi qu’un mentorat continu pour les aider à créer des micro-entreprises de trois personnes et à constituer des groupes d’épargne. Nous soutenons Village Enterprise en Ouganda, où l’organisation est active depuis 2016. Aujourd’hui, ses activités s’étendent dans plusieurs pays d’Afrique subsaharienne et ont pour objectif de permettre à plus de 20 millions de personnes d’échapper à la pauvreté d’ici 2030. Notre collaboration avec Village Enterprise n’a eu de cesse d’évoluer ces dernières années jusqu’à devenir un partenariat solide, axé sur le dialogue, la transparence et la confiance. En plus d’un soutien financier flexible, nous sommes fiers de les accompagner dans leurs discussions stratégiques et de les soutenir activement dans leurs démarches de recherche de financements supplémentaires.  Tostan a mis sur pied un modèle participatif sur trois ans qui permet aux jeunes, aux adultes, aux personnes âgées et aux leaders communautaires de se former aux droits de l’homme, à l’hygiène et à la santé, à la résolution de conflits, à l’autonomie économique et à l’éducation des enfants. Le programme aborde aussi des notions élémentaires de lecture, d’écriture et de calcul. Ce modèle de développement communautaire favorise le changement social et comportemental, en encourageant les villageois à remettre en question des pratiques dangereuses profondément ancrées. L’un des succès de Tostan est l’engagement de plus de 9 000 communautés à mettre fin au mariage des enfants et à l’excision. Nous soutenons Tostan au Sénégal depuis 2018 ; aujourd’hui nous finançons l’organisation pour qu’elle puisse toucher plus de 107 500 personnes vivant dans des communautés reculées en Gambie, au Sénégal et en Guinée-Bissau. Notre partenariat avec Tostan grandit et se révèle toujours plus authentique et pertinent année après année. Elena Bonometti, directrice de Tostan, parle d’une relation « transformative » avec Cartier Philanthropy, qui nous pousse ensemble à nous remettre en question et à être lucides face aux défis auxquels nous sommes confrontés et aux attentes qu’ils suscitent. Notre relation en sort renforcée et entièrement dédiée aux communautés que nous servons.  L ES C INQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 51"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg53.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 53-title" style="top:552px;left:84px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/53-title-1.png">
        <img class="abs halfScale 53-title" style="top:694px;left:85px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/53-text-1.png">
        <div class="contentLinkNone abs" style="top: 549px; left: 79px; width: 575px; height: 278px;" onclick="Publish.openArticle(6)"></div>
      `,
      "script": `
        function onPageEnter() {
          pg53Anim = new TimelineMax();
          pg53Anim
            .staggerFromTo(cOf("53-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
        }

        function onPageLeave() {
          pg53Anim.stop();
          resetNumbers("53-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Buildher, Kheyti, Healthy Learners et Proximity Designs ont été soutenus jusqu’à aujourd’hui  5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS Nous œuvrons dans un secteur où nous pouvons librement choisir quelle voie prendre. Nous définissons notre mission et notre vision et nous sélectionnons nos partenaires selon nos propres critères. Nous décidons de ce que nous allons considérer comme un succès ou un échec. Si nous voulons être vraiment sincères en matière de progrès et d’impact social, il nous faut alors évaluer les résultats sur la base de données rigoureuses et les assumer à travers une communication publique. Il nous semble important de révéler de manière transparente les résultats que nous attendons et les objectifs fixés. De même que nous célébrerons nos succès, il est également de notre devoir d’admettre et de partager nos échecs afin d’en tirer des leçons utiles pour tous. 52 - LE S CI N Q L EÇO N S TIR ÉES D ’ UN E D ÉCE NNIE D’ENG AG EMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 52,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg54.jpg",
      "zoom": null,
      "content": `
        <div class="contentLinkNone abs" style="    top: 301px; left: 62px; width: 569px; height: 525px;" onclick="Publish.openArticle(6)"></div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "IDinsight  Pays : Inde, Kenya, Myanmar, Zambie Financé depuis 2020  Les organisations à but non lucratif fournissent des services essentiels aux populations les plus pauvres du monde. Cette mission cruciale nécessite de disposer de données probantes pour optimiser la conception des programmes, améliorer leur mise en œuvre et maximiser leur impact. IDinsight est une organisation internationale de conseil, d’analyse de données et de recherche qui accompagne les leaders du développement à produire et à utiliser des données dans leur prise de décision. Nous soutenons depuis 2020 les efforts d’IDinsight pour faire évoluer leurs outils de collecte de données et d’analyse. L’organisation travaille également avec nombre de nos partenaires pour renforcer leurs méthodes de suivi et d’évaluation et leur apporter des services de conseils sur mesure. Ceci inclut notamment le renforcement des systèmes de données, la conception ou l’amélioration de la collecte, de l’analyse et de la visualisation des données, ainsi que la conception de théories du changement fondées sur des données probantes et concrètes.  International Center for Research on Women Pays : Rwanda, Tanzanie Financé depuis 2018  L’International Center for Research on Women (ICRW) est un institut de recherche qui s’attaque aux défis auxquels sont confrontés les femmes et les filles partout dans le monde. Nous soutenons ICRW depuis 2018 pour enrichir les connaissances théoriques et pratiques dans le domaine de la mobilisation des hommes et des garçons en faveur de l’égalité des genres. À la suite de l’étude Gender equity and male engagement : it only works when everyone plays (Équité des genres et engagement des hommes : ça ne marche que si tout le monde joue), un programme pilote a été lancé sur le terrain pour mettre en pratique les recommandations de l’étude et développer des stratégies efficaces sur ces questions. Ce pilote est mené au Rwanda et en Tanzanie sur cinq ans, afin de tester des stratégies d’engagement des hommes dans les programmes traditionnels destinés aux femmes de Women for Women International et de Hand in Hand International. Les résultats seront publiés, partagés avec l’ensemble du secteur, et permettront d’éclairer des prises de décisions programmatiques et de financement.  L ES CINQ LEÇ ONS T IRÉES D’UNE DÉC ENNIE D’ENG AG EMENT - 53"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 53,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg55.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 55-title" style="top:246px;left:100px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/55-title-1.png">
        <img class="abs halfScale 55-title" style="top:98px;left:145px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/55-text-1.png">
        <img class="abs halfScale 55-title" style="top:526px;left:184px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/55-text-2.png">
        <img class="abs halfScale 55-title" style="top:702px;left:97px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/55-text-3.png">

        <div class="single-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')" style="top: 330px; left: 516px;">
          <img class="abs 55-play halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play-big.png">
        </div>

        <div class="double-play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')" style="top: 318px; left: 615px;">
          <img class="abs 55-play halfScaleC animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play-big.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg55Anim = new TimelineMax();
          pg55Anim
            .staggerFromTo(cOf("55-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1)
            .fromTo(cOf("55-play"), 0.9, {className: '+= halfpulseBig', opacity:0, scale: 0}, {opacity: 1, scale: 0.4, ease: Power2.easeOut}, ">")
          
          if (Publish.isDoublePage) {
            cOf("single-play")[0].style.display = "none"
            cOf("single-play")[1].style.display = "none"
            cOf("double-play")[0].style.display = "block"
          } else {
            cOf("single-play")[0].style.display = "block"
            cOf("single-play")[1].style.display = "block"
            cOf("double-play")[0].style.display = "none"
          }
        }

        function onPageLeave() {
          pg55Anim.stop();
          resetNumbers("55-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Je dirais catalyseur, car Cartier CATA LYSEUR «Philanthropy investit aujourd’hui  dans des solutions et des idées qui vont, nous l’espérons, changer le secteur et le domaine du développement pour les années à venir. » Meg Battle, Directrice des initiatives stratégiques chez IDinsight  QUEL MOT CHOISISSENT NOS PARTENAIRES POUR NOUS DÉCRIRE  Je choisirais le mot solidarité pour définir SOL ID ARI TÉ «Cartier Philanthropy. Votre équipe comprend  que le travail que nous réalisons ensemble n’est ni une question de pitié ni de problèmes qui ne nous concernent pas, mais qu’il a trait aux injustices et aux disruptions dans un monde qui est de notre responsabilité collective. Il s’agit pour nous de résoudre ces problèmes et de réparer ces injustices ensemble, en tant que partenaires respectifs et partenaires des patients. » Ari Johnson, PDG de Muso  Je vais tricher et utiliser une locution pour dire : CONF IANCE «confiance dans le changement. Non seulement Cartier  Philanthropy finance des organisations fortes, mais surtout, elle leur fait confiance, créant ainsi une latitude pour que l’organisation puisse rester fidèle à sa mission, mais aussi afin qu’elle se développe. Pour moi, c’est l’essence même de la confiance. » Frank Beadle de Palomo, PDG de mothers2mothers  54 -"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 54,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg56.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 56-title" style="top:99px;left:201px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/56-text-1.png">
        <img class="abs halfScale 56-title" style="top:232px;left:109px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/56-text-2.png">
        <img class="abs halfScale 56-title" style="top:394px;left:188px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/56-text-3.png">
        <img class="abs halfScale 56-title" style="top:557px;left:165px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/56-text-4.png">
        <img class="abs halfScale 56-title" style="top:702px;left:77px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/56-text-5.png">
        <div class="single-play play pointer abs" onclick="Publish.openVideo('/a-decade-of-effective-philanthropy/fr/static/_content/2022-CP-COM-In-Our-Partners-Words-05.mp4')" style="top: 18px; left: 0px;">
          <img class="abs 56-play halfScaleC halfpulseBig animatedpulse" src="/a-decade-of-effective-philanthropy/fr/static/_content/play-big.png">
        </div>
      `,
      "script": `
        function onPageEnter() {
          pg56Anim = new TimelineMax();
          pg56Anim
            .staggerFromTo(cOf("56-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.15)
            .fromTo(cOf("56-play"), 0.9, {className: '+= halfpulseBig', opacity:0, scale: 0}, {opacity: 1, scale: 0.4, ease: Power2.easeOut}, ">")

          
          if (!Publish.isDoublePage) {
            cOf("single-play")[0].style.display = "block"
            cOf("single-play")[1].style.display = "block"
            cOf("double-play")[0].style.display = "none"
          }
        }

        function onPageLeave() {
          pg56Anim.stop();
          resetNumbers("56-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "Sans aucun doute l’empathie. Surtout E MPATHI E «quand je sais que vous avez dédié beaucoup de votre temps à l’écoute et à la compréhension de ce qui se passe, tant avec vos partenaires que sur le terrain. » Debbie Aung Din, Co-fondatrice de Proximity Design  A P PRENT ISSAGE CO N TI N U  « Cartier Philanthropy a toujours soutenu la nécessité d’un apprentissage continu, une valeur partagée avec Room to Read ; nous nous engageons tous deux à trouver des solutions dans ce monde en constante évolution. Loin d’être figés dans nos croyances, nous continuons à écouter les retours du terrain tout en n’ayant de cesse d’apprendre. » Geetha Murali, PDG de Room to Read  Je choisirais réfléchie. Je pense que Cartier RÉ F LÉ CHI E «Philanthropie est une fondation très avisée  dans le choix de ses partenariats, dans les relations qu’elle entretient avec eux et dans la façon dont elle leur fait confiance pour qu’ils prennent eux-mêmes les décisions qui permettront le meilleur impact. » Emily Bancroft, Présidente de VillageReach  d’ordre est impact. Et cela passe IMPA CT «parLeunmot apprentissage basé sur les faits et les  données, donc une philanthropie très réfléchie, qui cherche vraiment à comprendre comment faire de notre Terre un monde meilleur. » Laurie Adams, PDG de Women for Women International  Je choisirais transformatif. Notre relation T R A N SFORMATI F «a été transformative parce que l’équipe de  Cartier Philanthropy nous a toujours incités à remettre en question notre façon de travailler d’une manière constructive et a collaboré étroitement avec nous pour que notre action soit encore plus pertinente, vis à vis des gens que nous nous engageons à servir. » Elena Bonometti, PDG de Tostan  - 55"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 55,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg57.jpg",
      "zoom": null,
      "content": `
        <img class="abs halfScale 57-title" style="top:431px;left:54px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/57-title-1.png">
        <img class="abs halfScale 57-title" style="top:464px;left:53px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/57-title-2.png">
        <img class="abs halfScaleC 57-text" style="top:-467px;left:-182px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/57-text-1.png">
        <img class="abs halfScaleC 57-text" style="top:182px;left:-105px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/57-text-2.png">
        <div class="57-text"></div>
        <img class="abs halfScaleC 57-text" style="top:241px;left:469px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/58-text-2.png">

      `,
      "script": `
        function onPageEnter() {
          pg57Anim = new TimelineMax();
          pg57Anim
            .staggerFromTo(cOf("57-title"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.3)
            .staggerFromTo(cOf("57-text"), 1, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 0.3, 1.9)
        }

        function onPageLeave() {
          pg57Anim.stop();
          resetNumbers("57-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "ACCÈS AUX SERVICES DE BASE Éducation Ashesi University CorStone Imagine Worldwide Institut Européen de Coopération et de Développement (IECD) The Luminos Fund Ubongo  Eau, assainissement, nutrition 1001fontaines Semilla Nueva SOIL Water and Sanitation for the Urban Poor (WSUP)  Santé Development Media International (DMI) Healthy Learners MiracleFeet Muso Pivot Santé Integrée UNFPA Supplies Partnership VillageReach  PARTENAIRES  ACTUELS 2022 MODES DE SUBSISTANCE ET ÉCOSYSTÈMES DURABLES BRAC Fonkoze Foundation Hand in Hand International  56 -  Kheyti myAgro One Acre Fund Proximity Designs  Root Capital Village Enterprise VisionSpring World Bicycle Relief"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 56,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg58.jpg",
      "zoom": null,
      "content": `
      <img class="abs halfScaleC 58-text" style="top:-467px;left:-896px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/57-text-1.png">
      <img class="abs halfScaleC 58-text" style="top:182px;left:-819px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/57-text-2.png">
      <img class="abs halfScaleC 58-text" style="top:-329px;left:-243px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/58-text-1.png">
      <img class="abs halfScaleC 58-text" style="top:241px;left:-245px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/58-text-2.png">
      <img class="abs halfScaleC 58-text" style="top:566px;left:310px;" src="/a-decade-of-effective-philanthropy/fr/static/_content/58-text-3.png">
      `,
      "script": `
        function onPageEnter() {
          pg58Anim = new TimelineMax();
          pg58Anim
            .staggerFromTo(cOf("58-text"), 1, {scale: 0}, {scale: 0.5, ease: Power2.easeOut}, 0.3, 1.9)
        }

        function onPageLeave() {
          pg58Anim.stop();
          resetNumbers("58-no");
          removeContentLinks();
          removeContentLinksThree();
        }
      `,
      "searchText": "DÉVELOPPEMENT SOCIAL ET ÉCONOMIQUE DES FEMMES Co-Impact Santé des femmes mothers2mothers MSI Reproductive Choices (MSI) StrongMinds  Opportunités économiques The BOMA Project International Center for Research on Women (ICRW) Saha Global Women for Women International  RÉPONSE AUX SITUATIONS D’URGENCE International Rescue Committee (IRC) Medair Médecins Sans Frontières (MSF)  Programme alimentaire mondial (PAM) SOS Méditerranée  Éducation et compétences de vie Asian University for Women Buildher Educate Girls Room to Read Tostan  SUPPORT TECHNIQUE Appleseed IDinsight  - 57"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 57,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg59.jpg",
      "zoom": null,
      "content": `
        <div class="contentLink" style="top: 739px; left: 83px; width: 196px; height: 20px;"> <a href="https://www.cartierphilanthropy.org" target="_blank"></a> </div>
      `,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Crédits photos Couverture : © Cartier Philanthropy / Cyril Le Tourneur © 1001Fontaines (p. 13) © Action contre la Faim / Lucile Grosjean (p. 36) © The BOMA Project (p. 21) © Buildher (p. 48) © Cartier Philanthropy / Andrea Borgarello (p. 12, 19, 24-25, 23, 29, 32, 38, 43, 46) © Cartier Philanthropy / Cyril Le Tourneur (p. 14, 16, 18, 23, 27, 42) © Cartier Philanthropy / Irene Amodei (p. 33) © Cartier Philanthropy / Karin Schermbrucker (p.1, 7, 17, 44) © CorStone (p. 10) © Fédération internationale des sociétés de la Croix-Rouge et du Croissant-Rouge (p. 36) © Hand in Hand International / Georgina Goodwin (p. 49) © Healthy Learners (p. 45) © International Rescue Committee (p. 11) © International Rescue Committee / A. Oberstadt Richmond (p. 33) © The Luminos Fund / Rosie Hallam (p. 41)  Adresse Rue André-De-Garrini 3 – CH-1217 Meyrin-Genève  Site internet www.cartierphilanthropy.org  58 -  © The Luminos Fund / Aron Simeneh (p.10) © Medair / Chrystelle Rakotomavo (p. 37) © Medair / Megan Fraga (p. 31) © Medair (p. 35) © Médecins Sans Frontières / Agnes Varraine Leca (p. 35) © Médecins Sans Frontières / Benoit Finck (p. 37) © Médecins Sans Frontières / Premananda Hessenkamp (p. 35) © mothers2mothers / Karin Schermbrucker (p. 40) © One Acre Fund / Hailey Tucker (p. 27) © Pivot (p. 9) © Root Capital (p. 26) © Saha Global (p. 20) © Santé Integrée (p. 8) © Semilla Nueva (p. 12) © SOIL / Vic Hinterlang (p. 12) © StrongMinds / Jennifer Bass (p. 16) © SOS Méditerranée / Hara Kaminara (p. 32) © Techo (p. 34) © Tostan (p. 47) © Women for Women International / Hazel Thomson (p. 20) © World Bicycle Relief (p. 28)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 58,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg60.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))
        
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) { 
          return e.className = 'addContentLinkThree'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = " ";
          var decChar = ",";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function animateNumbers(klass, delay = 1, stagger = 0.3) {
        numbers = cOf(klass)
      
        setTimeout(function() {
          for (let i = 0; i < numbers.length; i++) {
            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])
          }
        }, delay * 1000)
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
    "articles": [{
      "title": "MESSAGE DU PRÉSIDENT",
      "pageIndex": 6,
      "subIndex": 0,
      "articleIndex": 0,
      "article": `
        <h2>MESSAGE DU PRÉSIDENT</h2>  

        <p>La mission de Cartier est de trouver la beauté, où qu’elle soit. Nous sommes
          à son service et, tous les jours, nous nous eff orçons de la sublimer afi n
          qu’elle perdure pour les générations à venir.</p>
        
        <p>Nous estimons qu’il est de notre responsabilité, à la fois en tant qu’être
          humain et en tant qu’entreprise, de cultiver et de protéger la beauté du
          monde, et de faire tout notre possible pour la restaurer quand elle a été
          détériorée ou brisée. La vie humaine est évidemment l’une des</p>
        beautés du monde.
        
        <p>La beauté, telle que nous la concevons, est donc un idéal qui ne peut être
          atteint que par le soin, le respect, la dignité et la compassion.</p>
        
        <p>Au cours de cette dernière décennie, Cartier Philanthropy a travaillé avec
          ténacité et efficacité pour améliorer la vie des communautés les plus
          vulnérables et les plus marginalisées de la planète, afin qu’elles puissent
          non seulement survivre aux épreuves, mais vivre, profiter et participer
          pleinement à la beauté du monde. Une jeune fille qui termine avec succès sa
          scolarité, une communauté d’agriculteurs prospère, un endroit sûr où trouver
          refuge et se reconstruire, un nouveau-né en bonne santé… sont autant
          d’expressions de la beauté - une beauté vivante.</p>
        
        <p>Cartier Philanthropy soutient des organisations dont la mission est de donner
          aux femmes, aux enfants et à des communautés entières les ressources, les
          compétences et les opportunités dont ils ont besoin pour vivre pleinement. Au
          fil des années, de solides partenariats ont été noués et construits sur des
          valeurs communes et un engagement mutuel en faveur d’une philanthropie
          efficace.</p>
        
        <p>Le chemin est encore long. En effet, à certaines occasions, il peut même nous
          paraître plus sinueux qu’il ne l’était il y a dix ans. Mais chaque pas et
          chaque vie changée viennent
          réaffirmer notre confiance et notre détermination, et ouvrent en peu plus la
          voie afin que d’autres nous rejoignent pour créer ensemble de nouvelles
          beautés dans le monde.</p>

        <!-- <p>
          <b>Cyrille Vigneron</b><br>
          CEO of Cartier,<br>
          President of the Board,<br>
          Cartier Philanthropy
        </p> -->
      `,
    },{
      "title": "MESSAGE DE LA CONSEILLÈRE STRATÉGIQUE",
      "pageIndex": 7,
      "subIndex": 0,
      "articleIndex": 1,
      "article": `
        <h2>MESSAGE DE LA CONSEILLÈRE STRATÉGIQUE</h2> 
        <p>Quelle aventure ces dix dernières années !</p>
        <p>Et quel privilège que celui de guider Cartier Philanthropy, des promesses
          initiales aux progrès tangibles, en créant un solide réseau de partenaires
          dont nous sommes très fiers !</p>
        <p>Nous sommes aujourd’hui heureux de voir, aux quatre coins du monde, des
          communautés plus fortes et pleines de ressources, en mesure de surmonter de
          sérieux obstacles et de vivre enfin comme elles le méritent.</p>
        <p>Cartier Philanthropy a été fondé il y a dix ans afin de participer à la
          construction d’un monde dans lequel chacun peut réaliser son potentiel. Au
          cours de la dernière décennie, nous nous sommes concentrés sur cette ambition
          de manière stratégique. Nous avons choisi de nous focaliser sur les endroits
          les plus vulnérables de la planète et avons progressivement défini le cadre de
          notre champ d’action, en accordant une attention particulière aux inégalités
          qui maintiennent les gens dans la pauvreté.</p>
        La philanthropie relève de l’action collective et d’objectifs communs. Avec nos
        partenaires, nous nous attaquons sans relâche à ces inégalités, qu’elles soient
        liées au genre, à l’accès aux services essentiels ou au manque de ressources
        matérielles et sociales. Ce rapport met en lumière l’impact de notre engagement
        collectif et les changements concrets qui ont permis d’améliorer la vie des plus
        démunis. C’est notre façon d’honorer nos partenaires pour leur courage et leur
        détermination dans leur combat au service des plus vulnérables, quelles que
        soient les difficultés.
        <p>Car ce combat est aussi le nôtre.</p>
        <p>Conscients qu’une évolution significative et durable ne se produit que si
          nous nous concentrons aussi sur notre façon de donner afin de contribuer à un
          impact social fort, nous partageons aussi dans ce rapport certaines des leçons
          que nous avons apprises en chemin, nous aidant à devenir une fondation
          meilleure, plus efficace, responsable et participante.</p>
        <p>Construire une société inclusive, équitable et plus sûre, qui offre à chacun
          la possibilité de mener une vie épanouissante, reste un impératif moral et le
          défi de notre époque. Notre engagement demeure inchangé, tout comme notre
          ambition de soutenir et de déployer des interventions éprouvées à l’échelle
          des besoins du plus grand nombre.</p>

        <!-- <p>
          <b>Pascale de la Frégonnière</b><br>
          Strategic Advisor to the Board,<br>
          Cartier Philanthropy
        </p> -->
      `,
    },{
      "title": "1. FINANCER L’IMPACT",
      "pageIndex": 43,
      "subIndex": 0,
      "articleIndex": 2,
      "article": `
        <h2>1. FINANCER L’IMPACT.</h2> 
        <p>Il y a tant à faire aujourd’hui - et les besoins sont si urgents - que nous ne pouvons pas nous permettre de gaspiller de l’argent, du temps ou de l’énergie sur des programmes qui ne fonctionnent pas.</p>
        <p>Notre première responsabilité, en tant que bailleur, est de nous assurer que chaque dollar investi apporte un changement positif, concret et tangible dans la vie des personnes pour lesquelles nous nous engageons. Pour ce faire, nous devons soutenir des solutions éprouvées, étayées par des données probantes, et qui auront des résultats impactants.</p>
        <p><b>mothers2mothers</b><br>
        Pays : Ouganda<br>
        Financé depuis 2017</p>
        <p>mothers2mothers (m2m) emploie des femmes vivant avec le VIH-SIDA afin qu’elles facilitent l’accès d’autres femmes et de leur famille aux services essentiels et aux soins de santé.
          Le programme se concentre sur la réduction du risque d’infection au VIH et aux maladies associées. Depuis 2017, notre soutien a permis à m2m de déployer ses services de santé intégrée en Ouganda pour réduire la transmission du virus des femmes enceintes et séropositives à leur bébé et pour préserver plus en général la santé des femmes et des enfants.
          </p>
        <p>Au cours de ces vingt dernières années, les efforts de m2m ont permis l’élimination presque totale de la transmission du virus de la mère à l’enfant parmi les femmes encadrées par son programme : en Afrique orientale et australe, le taux de transmission du VIH de ces femmes à leur enfant est passé de 40 % à 0,8 % et la mortalité infantile a été abaissée à deux décès pour 1 000 naissances.</p>
        <p><b>The Luminos Fund</b><br>
        Pays : Éthiopie<br>
        Financé depuis 2018</p>
        <p>Le programme d’apprentissage accéléré de Luminos Fund, « Seconde Chance », a déjà permis à plus de 152 000 enfants africains, qui n’ont jamais été scolarisés ou qui ont
          dû interrompre leur éducation à cause de la pauvreté, d’un conflit ou de la discrimination, de retrouver les bancs de l’école. Depuis 2018, nous soutenons l’expansion rapide du programme dans les régions reculées d’Afar et d’Oromia, en Éthiopie.
          </p>
        <p>Parmi les 26 850 élèves inscrits dans les classes de « Seconde Chance », entre 2018 et 2021, 91 % à 97 % d’entre eux ont réussi leur transition vers des écoles publiques et poursuivent leur éducation. Quelque 9 000 enfants supplémentaires ont bénéficié du programme mis en oeuvre directement par le gouvernement. Six ans plus tard, 75 % des élèves de « Seconde Chance » sont toujours scolarisés.</p>
      `,
    },{
      "title": "2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION",
      "pageIndex": 45,
      "subIndex": 0,
      "articleIndex": 3,
      "article": `
        <h2>2. UN FINANCEMENT À LONG TERME ET SANS RESTRICTION.</h2> 
        <p>Nous travaillons sur des questions très complexes et multidimensionnelles et, à ce titre, nous ne nous attendons pas à des résultats immédiats, d’un jour à l’autre. Notre engagement se fait sur le long terme. Soutenir des projets sur deux ou trois ans seulement reviendrait à choisir une approche de type « cases à cocher ». Nous avons fait le choix d’investir sur le long terme et sur la création d’alliances solides, en aidant nos partenaires à se développer, à renforcer leur impact et à élargir le champ de leurs opérations. Fournir un financement sans restriction, que les organisations à but non lucratif gèrent comme elles l’entendent, est sûrement la mesure la plus transformatrice que nous puissions prendre pour véritablement les aider à atteindre leurs objectifs.</p>
        <p><b>Educate Girls</b><br>
        Pays : Inde<br>
        Financé depuis 2014</p>
        <p>Educate Girls s’attaque aux inégalités entre les sexes et aux barrières qui empêchent les filles d’aller à l’école dans les villages ruraux les plus isolés de l’Inde. Partant d’un projet pilote portant sur 50 écoles en 2007, Educate Girls couvre aujourd’hui plus de 20 000 villages au Rajasthan, au Madhya Pradesh et en Uttar Pradesh.</p>
        <p>Au fil des ans, Educate Girls a obtenu des résultats impressionnants en matière d’inscription, de rétention et d’apprentissage. Les visites à domicile et la sensibilisation des communautés sont au cœur de son succès. Educate Girls exploite également les ressources gouvernementales pour améliorer les infrastructures, la gouvernance et l’enseignement des écoles publiques.</p>
        <p>Nous finançons l’approche unique d’Educate Girls depuis 2014, contribuant à la scolarisation de plus de 1,1 million de filles. Aujourd’hui, nous soutenons l’organisation pour qu’elle touche 1,5 million de filles d’ici 2024.</p>
        <p><b>Room to Read</b><br>
        Pays : Bangladesh, Cambodge, sans restriction<br>
        Financé depuis 2019</p>
        <p>Room to Read cherche à transformer la vie de millions d’enfants vivant dans des communautés à faible revenu en se concentrant sur l’alphabétisation et l’égalité des genres dans l’éducation. En collaborant avec les communautés locales, les gouvernements et des organisations partenaires, Room to Read développe l’alphabétisation et inculque l’habitude de la lecture aux enfants des écoles primaires.</p>
        <p>Depuis 2019, nous soutenons son Programme d’éducation pour les filles au Bangladesh et au Cambodge, permettant aux adolescentes d’acquérir et de mettre en pratique - par des cours, des ateliers et des activités extrascolaires - des connaissances et des compétences de vie afin qu’elles puissent poursuivre leurs études et prendre des décisions éclairées pour leur futur. Depuis juillet 2022, nous offrons à l’organisation un soutien financier sans restriction.</p>
      `,
    },{
      "title": "3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX",
      "pageIndex": 47,
      "subIndex": 0,
      "articleIndex": 4,
      "article": `
        <h2>3. INNOVER C’EST BIEN, MAIS RENDRE ACCESSIBLES AU PLUS GRAND NOMBRE DES SOLUTIONS ÉPROUVÉES C’EST ENCORE MIEUX.</h2> 
        <p>Au vu de l’urgence et de l’intensité des problèmes sociaux actuels, si l’ensemble de la communauté philanthropique est séduite par l’innovation et se concentre uniquement sur celle-ci, nous ne serons jamais en mesure de rendre accessibles au plus grand nombre les solutions qui fonctionnent déjà. En d’autres termes, nous n’avons pas besoin d’un million d’innovations, mais d’une seule qui fonctionne, répliquée un million de fois, afin que son impact soit à la hauteur des besoins.</p>
        <p><b>StrongMinds</b><br>
        Pays : Ouganda, Zambie<br>
        Financé depuis 2018</p>
        <p>L’OMS promeut les thérapies de groupe en tant qu’intervention de santé mentale de première ligne pour les populations vulnérables. StrongMinds est la seule organisation à mettre en oeuvre cette solution efficace pour lutter contre la dépression en Afrique. StrongMinds forme et supervise des agents communautaires pour qu’ils deviennent des animateurs en santé mentale chargés d’encadrer des groupes de parole. Ces thérapies ciblent les femmes souffrant de dépression au sein des communautés défavorisées, où la prévalence de la dépression, avec un taux affichant 25 %, est très présente. Des groupes de 10 à 15 femmes se réunissent pour des séances hebdomadaires de 90 minutes, où elles apprennent à identifier les déclencheurs de la dépression, elles partagent des stratégies permettant de combattre les symptômes et, à plus long terme, elles apprennent à devenir plus résilientes. StrongMinds permet ensuite aux femmes arrivées au terme du programme de se former pour encadrer leurs propres groupes de parole, ce qui amplifie l’impact du programme sur le long terme.</p>
        <p>Nous soutenons StrongMinds depuis 2018 afin que l’organisation développe en Zambie le modèle mis en place en Ouganda. L’organisation est désormais devenue conseillère technique du ministère zambien de la Santé en matière de santé mentale.</p>
        <p><b>Healthy Learners</b><br>
        Pays : Zambie<br>
        Financé depuis 2019</p>
        <p>Healthy Learners s’engage à améliorer la santé des enfants de plus de cinq ans grâce à son programme de santé communautaire en milieu scolaire. L’organisation forme les enseignants à reconnaître les symptômes des maladies courantes chez les élèves et à leur prodiguer les soins de base ou à les référer à des centres de santé. Plus vite l’enfant malade est identifié et soigné, plus vite il reprendra l’école.</p>
        <p>Depuis le début de notre collaboration en 2019, Healthy Learners a systématisé son programme et renforcé sa collaboration avec les ministères zambiens de la Santé et de l’Éducation pour inscrire ce dispositif dans la stratégie nationale de santé scolaire.</p>
      `,
    },{
      "title": "4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR",
      "pageIndex": 47,
      "subIndex": 0,
      "articleIndex": 5,
      "article": `
        <h2>4. TROUVER LE BON ÉQUILIBRE DANS LA DYNAMIQUE DU POUVOIR.</h2> 
        <p>Lorsqu’il est question de modifier ou d’améliorer les pratiques philanthropiques, la responsabilité incombe aux bailleurs. La dynamique du pouvoir exige que les bailleurs eux-mêmes remettent en question la nature de leurs relations avec les organisations financées. Il faut donc avant tout reconnaître l’existence d’un déséquilibre de pouvoir qui peut empêcher, s’il n’est pas assumé, une collaboration honnête et fructueuse. Nos partenaires attendent de nous que nous soyons flexibles, pragmatiques, à l’écoute de leurs besoins et de leurs difficultés et prêts à amplifier et à faire connaître leur travail. Mais avant toute chose, ils ont besoin de notre confiance. Ces dernières années, nous avons intentionnellement créé des occasions d’échanges avec nos partenaires afin qu’ils puissent librement exprimer leurs doutes, remettre en question nos demandes ou exposer les changements de stratégie envisagés. Favoriser ainsi le dialogue a permis d’établir des relations de confiance, qui sont à la base des progrès réalisés ensemble.</p>
        <p><b>Village Enterprise</b><br>
        Pays : Ouganda<br>
        Financé depuis 2016</p>
        <p>Le programme de formation de Village Enterprise vient en aide aux personnes vivant dans l’extrême pauvreté, en leur permettant de développer des moyens de subsistance durables. L’organisation fournit aux participants une aide financière, une formation en entrepreneuriat et en finance, ainsi qu’un mentorat continu pour les aider à créer des micro-entreprises de trois personnes et à constituer des groupes d’épargne.</p>
        <p>Nous soutenons Village Enterprise en Ouganda, où l’organisation est active depuis 2016. Aujourd’hui, ses activités s’étendent dans plusieurs pays d’Afrique subsaharienne et ont pour objectif de permettre à plus de 20 millions de personnes d’échapper à la pauvreté d’ici 2030. Notre collaboration avec Village Enterprise n’a eu de cesse d’évoluer ces dernières années jusqu’à devenir un partenariat solide, axé sur le dialogue, la transparence et la confiance. En plus d’un soutien financier flexible, nous sommes fiers de les accompagner dans leurs discussions stratégiques et de les soutenir activement dans leurs démarches de recherche de financements supplémentaires.</p>
        <p><b>Tostan</b><br>
        Pays : Gambie, Guinéee-Bissau et Sénégal<br>
        Financé depuis 2016</p>
        <p>Tostan a mis sur pied un modèle participatif sur trois ans qui permet aux jeunes, aux adultes, aux personnes âgées et aux leaders communautaires de se former aux droits de l’homme, à l’hygiène et à la santé, à la résolution de conflits, à l’autonomie économique et à l’éducation des enfants. Le programme aborde aussi des notions élémentaires de lecture, d’écriture et de calcul. Ce modèle de développement communautaire favorise le changement social et comportemental, en encourageant les villageois à remettre en question des pratiques dangereuses profondément ancrées. L’un des succès de Tostan est l’engagement de plus de 9 000 communautés à mettre fin au mariage des enfants et à l’excision.</p>
        <p>Nous soutenons Tostan au Sénégal depuis 2018 ; aujourd’hui nous finançons l’organisation pour qu’elle puisse toucher plus de 107 500 personnes vivant dans des communautés reculées en Gambie, au Sénégal et en Guinée-Bissau. Notre partenariat avec Tostan grandit et se révèle toujours plus authentique et pertinent année après année. Elena Bonometti, directrice de Tostan, parle d’une relation « transformative » avec Cartier Philanthropy, qui nous pousse ensemble à nous remettre en question et à être lucides face aux défis auxquels nous sommes confrontés et aux attentes qu’ils suscitent. Notre relation en sort renforcée et entièrement dédiée aux communautés que nous servons.</p>
      `,
    },{
      "title": "5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS",
      "pageIndex": 47,
      "subIndex": 0,
      "articleIndex": 6,
      "article": `
        <h2>5. S’ENGAGER SUR DES RÉSULTATS ET ASSUMER SES RESPONSABILITÉS.</h2> 
        <p>Nous œuvrons dans un secteur où nous pouvons librement choisir quelle voie prendre. Nous définissons notre mission et notre vision et nous sélectionnons nos partenaires selon nos propres critères. Nous décidons de ce que nous allons considérer comme un succès ou un échec. Si nous voulons être vraiment sincères en matière de progrès et d’impact social, il nous faut alors évaluer les résultats sur la base de données rigoureuses et les assumer à travers une communication publique. Il nous semble important de révéler de manière transparente les résultats que nous attendons et les objectifs fixés. De même que nous célébrerons nos succès, il est également de notre devoir d’admettre et de partager nos échecs afin d’en tirer des leçons utiles pour tous.</p>
        <p><b>IDinsight</b><br>
        Pays : Inde, Kenya, Myanmar, Zambie<br>
        Financé depuis 2020</p>
        <p>Les organisations à but non lucratif fournissent des services essentiels aux populations les plus pauvres du monde. Cette mission cruciale nécessite de disposer de données probantes pour optimiser la conception des programmes, améliorer leur mise en oeuvre et maximiser leur impact. IDinsight est une organisation internationale de conseil, d’analyse de données et de recherche qui accompagne les leaders du développement à produire et à utiliser des données dans leur prise de décision. </p>
        <p>Nous soutenons depuis 2020 les efforts d’IDinsight pour faire évoluer leurs outils de collecte de données et d’analyse. L’organisation travaille également avec nombre de nos partenaires pour renforcer leurs méthodes de suivi et d’évaluation et leur apporter des services de conseils sur mesure. Ceci inclut notamment le renforcement des systèmes de données, la conception ou l’amélioration de la collecte, de l’analyse et de la visualisation des données, ainsi que la conception de théories du changement fondées sur des données probantes et concrètes.</p>
        <p><b>International Center for Research on Women</b><br>
        Pays : Rwanda, Tanzanie<br>
        Financé depuis 2018</p>
        <p>L’International Center for Research on
          Women (ICRW) est un institut de recherche
          qui s’attaque aux défis auxquels sont
          confrontés les femmes et les filles partout
          dans le monde. Nous soutenons ICRW
          depuis 2018 pour enrichir les connaissances
          théoriques et pratiques dans le domaine
          de la mobilisation des hommes et des garçons
          en faveur de l’égalité des genres.
          </p>
        <p>À la suite de l’étude Gender equity and male engagement : it only works when everyone plays (Équité des genres et engagement des hommes : ça ne marche que si tout le monde joue), un programme pilote a été lancé sur le terrain pour mettre en pratique les recommandations de l’étude et développer des stratégies efficaces sur ces questions. Ce pilote est mené au Rwanda et en Tanzanie sur cinq ans, afin de tester des stratégies d’engagement des hommes dans les programmes traditionnels destinés aux femmes de Women for Women International et de Hand in Hand International. Les résultats seront publiés, partagés avec l’ensemble du secteur, et permettront d’éclairer des prises de décisions programmatiques et de financement.</p>
      `,
    }]}



// WEBPACK FOOTER //
// ./src/document.js